import { useState, useEffect, useRef } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useNavigate, NavLink, useParams, useLocation } from 'react-router-dom';
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import html2canvas from 'html2canvas';
// import jsPDF from 'jspdf'; 
import { jsPDF as JsPDF } from 'jspdf'; 
import { toWords } from 'number-to-words';

// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';

import * as userActions from "../../actions/userActions";
import AccessDenied from '../common/AccessDenied';

import * as leadActions from "../../actions/leadActions";
import DisbursementMemoPage from './DisbursementMemoPage';
// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------


const ApplicationDetails = (props) => {
    const { leadId, id } = useParams();
    const location = useLocation();
    const { actions, usersData, fetchLeadIdDocument, allLeadDocumentByLeadData, userRoleType, isActive,leadInfo,backToLeadHandler,enableCamDetailsHandler,selectionVersioningID } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();

    const [allUsers, setAllUsers] = useState([]);
    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [getLeadId, setLeadId] = useState('');
    const [allUploadLeadDocument, setAllUploadLeadDocument] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');
    const formRef = useRef(null);
    const [propLeadId, setPropLeadId] = useState('');
    const [allDocumentTypeData, setAllDocumentTypeData] = useState([]);
    const [open, setOpen] = useState(false);
    const [viewModalInfo, setViewModalInfo] = useState([]);
    const [isVerifyDocChecked, setIsVerifyDocChecked] = useState(false);

    const [activeAllSancationDocs, setActiveAllSancationDocs] = useState([]);
    const [allLeadCheckLists, setAllLeadCheckLists] = useState([]);
    const [activeAccordionSections, setActiveAccordionSections] = useState([]);

      const [anchorCategories, setAnchorCategories] = useState([]);  
      const [speciallyAbledArr, setSpeciallyAbledArr] = useState([]);
      const [residenceTypesArr, setResidenceTypesArr] = useState([]);
      const [bankingUpiArr, setBankingUpiArr] = useState([]);
      const [constitutionArr, setConstitutionArr] = useState([]);
      const [customerTypeArr, setCustomerTypeArr] = useState([]);
      const [vehicleMakerArr, setVehicleMakerArr] = useState([]);
      const [vehicleUseArr, setVehicleUseArr] = useState([]);
      const [insuranceArr, setInsuranceArr] = useState([]);
      const [vehicleModelsArr, setVehicleModelsArr] = useState([]);
      const [businessValidationProofArr, setBusinessValidationProofArr] = useState([]);
      const [turnoverIncomeArr, setTurnoverIncomeArr] = useState([]);
      const [workingCapitalCycleArr, setWorkingCapitalCycleArr] = useState([]);
      const [addedLeadCoapplicantGuarantorRows, setAddedLeadCoapplicantGuarantorRows] = useState([]);
      const [coapplicantGuarantorRows, setCoapplicantGuarantorRows] = useState([]);
      const [religionsRows, setReligionsRows] = useState([]);
      const [categoryRows, setCategoryRows] = useState([]);
      const [motherNameRows, setMotherNameRows] = useState([]);
      const [alternateMobileRows, setAlternateMobileRows] = useState([]);
      const [educationDetailsRows, setEducationDetailsRows] = useState([]);
      const [educationalBackgroundRows, setEducationalBackgroundRows] = useState([]);
      const [parmanentAddressRows, setParmanentAddressRows] = useState([]);
      const [noOfDependentsRows, setNoOfDependentsRows] = useState([]);
      const [preferredLanguageRows, setPreferredLanguageRows] = useState([]);
      const [accountTypeArr, setAccountTypeArr] = useState([]);
      const [crifDetails, setCrifDetails] = useState([]);  
      const [bankDetails, setBankDetails] = useState([]); 
      const [camApprovalHistory, setCamApprovalHistory] = useState([]); 
      
        const [cAMMarginMoney, setCAMMarginMoney] = useState(0);
        const [annualIrr, setAnnualIrr] = useState(null);
        const [error, setError] = useState(null);
        const [showSanctionNote, setShowSanctionNote] = useState('');
        const [sanctionApproveLatestStatus, setSanctionApproveLatestStatus] = useState(0);
        const [sanctionApproveAndSendMailLatestStatus, setSanctionApproveAndSendMailLatestStatus] = useState(0);
        const [approveBtnAction, setApproveBtnAction] = useState(0);
        const [sendEmailBtnAction, setSendEmailBtnAction] = useState(0);
        const [openRejectAmt, setOpenRejectAmt] = useState(false);
        const [proposedRejectAmt, setproposedRejectAmt] = useState('');
        const [noOfAssetsToBeFinancedAfter, setNoOfAssetsToBeFinancedAfter] = useState('');
        const [multiofTotalAssetsNoofAssets, SetMultiofTotalAssetsNoofAssets] = useState('');
    
    const [isFIOpen, setIsFIOpen] = useState(false);
    const [isMiscOpen, setIsMiscOpen] = useState(false);
    const [isApplicantOpen, setIsApplicantOpen] = useState(false);
    const [isCoApplicantOpen, setIsCoApplicantOpen] = useState(false);
    const [isGuarantorOpen, setIsGuarantorOpen] = useState(false);
    const [applicationDetailsFormStatus, setApplicationDetailsFormStatus] = useState(true);
    const [applicationDetailsFormActiveTab, setApplicationDetailsFormActiveTab] = useState('application_details');
    const [enableUpdatePdfDetails, setEnableUpdatePdfDetails] = useState(false);
    const [refNo, setRefNo] = useState('');
    const [insuranceFor, setInsuranceFor] = useState('For insurance by ckers');
    const [dealerSubvention, setDealerSubvention] = useState('Dealer Subvention');

    const [insuranceForValue, setInsuranceForValue] = useState('');
    const [dealerSubventionValue, setDealerSubventionValue] = useState('');  

    const [loanAmountValue, setLoanAmountValue] = useState('');
    const [processingFeeOnFinanceAmountPlusGSTValue, setProcessingFeeOnFinanceAmountPlusGSTValue] = useState('');
    const [lessProcessingFeeIncludingGSTValue, setLessProcessingFeeIncludingGSTValue] = useState('');
    const [lessInsuranceByKotakMahindraValue, setLessInsuranceByKotakMahindraValue] = useState('');

    const [lessPreEmiTill5THJanValue, setLessPreEmiTill5THJanValue] = useState('');
    const [fileChargeValue, setFileChargeValue] = useState(''); 

    const [netDisbursementValue, setNetDisbursementValue] = useState('');
    const [nameOfSupplierDealerValue, setNameOfSupplierDealerValue] = useState(''); 

    const [exShowroomPriceValue, setExShowroomPriceValue] = useState('');
    const [insuranceAmounByDealerValue, setInsuranceAmounByDealerValue] = useState(''); 
    const [totalOnRoadPriceValue, setTotalOnRoadPriceValue] = useState(''); 
    const [assetValueVehicleVehiclesValue, setAssetValueVehicleVehiclesValue] = useState('');
    const [noOfAssetValue, setNoOfAssetValue] = useState('');
    const [totalDownPaymentByCustomerValue, setTotalDownPaymentByCustomerValue] = useState('');
    const [isReadyToModify, setIsReadyToModify] = useState(true);
    const [leadDetails, setLeadDetails] = useState([]);
    const [allLeadDocumentsArr, setAllLeadDocumentsArr] = useState([]);
    const [addedAllCoApplicants, setAddedAllCoApplicants] = useState([]);
    const [addedAllGuarantors, setAddedAllGuarantors] = useState([]);

    const [verticalTotalColspan, setVerticalTotalColspan] = useState(2);
    const [leadMoreDocuments, setLeadMoreDocuments] = useState([]);
    
 
    const [sourceDealerDetails, setSourceDealerDetails] = useState(``);
    const [currentDate, setCurrentDate] = useState(new Date());
    const [leadCity, setLeadCity] = useState('');
    const [leadName, setLeadName] = useState('');
    const [leadAddress, setLeadAddress] = useState('');
    const [camDetails, setCamDetails] = useState([]);
    const [savedApplicationDetailsInfo, setSavedApplicationDetailsInfo] = useState([]);
    const [savedSanctionDetailsInfo, setSavedSanctionDetailsInfo] = useState([]);
    
    const [lessPreEmiTill5thLabel, setLessPreEmiTill5thLabel] = useState('Less: Pre-EMI Till 5TH');
    const [amountOfProcessingFee, setAmountOfProcessingFee] = useState(0);
    const [lessProcessingFeeExcludingGST, setLessProcessingFeeExcludingGST] = useState(0);

    const [feeChargesPayable, setFeeChargesPayable] = useState(0);

    const [dearlerSubventionDedcuteAmount, setDearlerSubventionDedcuteAmount] = useState('');
    const [aprValue, setAprValue] = useState(0);

    const [totalMarginMoneyReceiptAmt, setTotalMarginMoneyReceiptAmt] = useState(0);
    const [netDisbursementAmt, setNetDisbursementAmt] = useState(0);
    const [emiAllVehicle, setEmiAllVehicle] = useState(0);
    const [sLTenure, setSLTenure] = useState(0);

    const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
    const [viewDetailsModalInfo, setViewDetailsModalInfo] = useState([]);

    const [loanAmountSchedule, setLoanAmountSchedule] = useState(0);
    const [interestRateSchedule, setInterestRateSchedule] = useState(0);  
    const [loanDurationSchedule, setLoanDurationSchedule] = useState(0);  
    const [paymentsPerYearSchedule, setPaymentsPerYearSchedule] = useState(0);
    const [allReligions, setAllReligions] = useState([]); 
    const [allSocialCategory, setAllSocialCategory] = useState([]); 
    const [allPreferredLanguage, setAllPreferredLanguage] = useState([]);     
    const [preloaderStatus, setPreloaderStatus] = useState(false);
    const [allDealers, setAllDealers] = useState([]); 
    const [dealerAddress, setDealerAddress] = useState('');
    const [dealerName, setDealerName] = useState('');
    const [dealerBenificaryName, setDealerBenificaryName] = useState('');
    const [dealerBankName, setDealerBankName] = useState('');
    const [dealerAccountNo, setDealerAccountNo] = useState('');
    const [dealerIfsc, setDealerIfsc] = useState('');

    const isAfterScheduleADate = (dateStr='') => {
        if(dateStr !== ''){
            const caseDate = new Date(dateStr.replace(' ', 'T'));
            const thresholdDate = new Date('2025-12-01T00:00:00');
            return caseDate >= thresholdDate;
        } 
         return false;         
    }; 

    function numberToIndianWords(num) {
        const a = [
            '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine',
            'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen',
            'seventeen', 'eighteen', 'nineteen'
        ];
        const b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

        const inWords = (n) => {
            if (n < 20) return a[n];
            if (n < 100) return `${b[Math.floor(n / 10)]}${n % 10 ? ` ${a[n % 10]}` : ''}`;
            if (n < 1000) return `${a[Math.floor(n / 100)]} hundred${n % 100 ? ` and ${inWords(n % 100)}` : ''}`;
            return '';
            };

        const units = [
            { value: 10000000, label: 'crore' },
            { value: 100000, label: 'lakh' },
            { value: 1000, label: 'thousand' },
            { value: 100, label: 'hundred' }
        ];

        if (num === 0) return 'zero';

        let result = '';
        units.forEach(({ value, label }) => {
            if (num >= value) {
                const count = Math.floor(num / value);
                result += `${inWords(count)} ${label} `;
                num %= value;
            }
            }); 

        if (num > 0) result += inWords(num);

        return result.trim();
        }

    useEffect(() => { 
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        actions.usersData(requestData);
        if (usersData.success) {
            setAllUsers(usersData.data);
        }
    }, []);

    const formattedDate = currentDate.toLocaleDateString('en-IN', {
         year: 'numeric',
        month: 'numeric',
        day: 'numeric',
      });

     

      function calculateAPR(tenureMonths, emi, netDisbursement) {
            const maxIterations = 100;
            const precision = 1e-6;

            // Validate inputs
            if (
                tenureMonths <= 0 ||
                emi <= 0 ||
                netDisbursement <= 0 ||
                Number.isNaN(tenureMonths) ||
                Number.isNaN(emi) ||
                Number.isNaN(netDisbursement)
            ) {
                return 0; // or return 'Invalid input' if you prefer
            }

            let rate = 0.1 / 12; // initial guess (10% annually)
            let iteration = 0;

            while (iteration < maxIterations) {
                let npv = 0;
                let derivative = 0;

                for (let i = 1; i <= tenureMonths; i += 1) {
                    npv += emi / ((1 + rate) ** i);
                    derivative += -i * emi / ((1 + rate) ** (i + 1));
                }

                npv -= netDisbursement;

                const newRate = rate - npv / derivative;

                if (Math.abs(newRate - rate) < precision) {
                    rate = newRate;
                    break;
                }

                rate = newRate;
                iteration += 1;
            }

            return (rate * 12 * 100).toFixed(2); // Return APR as percentage
        }

        

        const roundNumber = (num) => {
        if (!num && num !== 0) return 0; 
        return Math.round(num);
      };

        const generateSchedule = () => {
            const principal = parseFloat(loanAmountSchedule);
            const annualRate = parseFloat(interestRateSchedule) / 100;
            const totalPayments = loanDurationSchedule;
            const ratePerPeriod = annualRate / 12; 

           /* const principal = parseFloat(430000);
            const annualRate = parseFloat(20.82) / 100;
            const totalPayments = 42;
            const ratePerPeriod = annualRate / 12; */
 
            const schedule = [];
            const payment = principal * ratePerPeriod / (1 - (1 + ratePerPeriod) ** -totalPayments);
 

            let remainingBalance = principal;

            for (let i = 1; i <= totalPayments; i += 1) {
            const interest = remainingBalance * ratePerPeriod;
            const principalPayment = payment - interest;
            remainingBalance -= principalPayment;

            schedule.push({
                paymentNumber: i,
                payment: roundNumber(payment).toFixed(2),
                interest: roundNumber(interest).toFixed(2),
                principal: roundNumber(principalPayment).toFixed(2),
                balance: remainingBalance > 0 ? roundNumber(remainingBalance).toFixed(2) : '0.00'
            });
            }

            return schedule;
        };


    const schedule = generateSchedule();

      
      
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    
      const handleInputChange = (id, type, value) => {
        setReligionsRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value }];
        });
      };

      const handleInputsetCategoryChange = (id, type, value) => {
        setCategoryRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value }];
        });
      };

      const handleInputsetMotherNameChange = (id, type, value,field) => {
        setMotherNameRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value,field }];
        });
      };

      const handleInputsetAlternateMobileChange = (id, type, value,field) => {
        setAlternateMobileRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value,field }];
        });
      };

      const handleInputsetEducationDetailsChange = (id, type, value,field) => {
        setEducationDetailsRows((prev) => { 
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value,field }];
        });
      };

       const handleInputsetEducationalBackgroundChange = (id, type, value,field) => {
        setEducationalBackgroundRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value,field }];
        });
      };

      const handleInputsetParmanentAddressChange = (id, type, value,field) => {
        setParmanentAddressRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value,field }];
        });
      };

      const handleInputsetNoOfDependentsChange = (id, type, value,field) => {
        setNoOfDependentsRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type && entry.field === field);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            updated[existingIndex].field = field;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value,field }];
        });
      };

      const handleInputsetPreferredLanguageChange = (id, type, value) => {
        setPreferredLanguageRows((prev) => {
          const existingIndex = prev.findIndex((entry) => entry.id === id && entry.type === type);
    
          if (existingIndex !== -1) {
            // Update if already exists
            const updated = [...prev];
            updated[existingIndex].value = value;
            return updated;
          }  
            // Push new entry
            return [...prev, { id, type, value }];
        });
      };

      useEffect(() => {
        console.log("religionsRows updated:", religionsRows);
      }, [religionsRows,categoryRows,preferredLanguageRows,motherNameRows]);

    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}/${month}/${year}`;
    };

    const formatOnlyMonthYearValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const monthName = newDate.toLocaleString('en-US', { month: 'long' }); // Get full month name
    
        return `${monthName} ${year}`;
    };


    const clickCcmTab = () => {      
        backToLeadHandler('cam');
        enableCamDetailsHandler(true); 
        const timer = setTimeout(() => {
            const divElement = document.getElementById("pills-disbursement_memo-tab");
            if (divElement) {
              divElement.click(); 
            }
          }, 2000);       
          return () => clearTimeout(timer); 
      };

      useEffect(() => { 
        if (leadInfo?.data?.length > 0) {

            const leadDetailsVal = leadInfo.data[0];
            setLeadDetails(leadDetailsVal);

            const name = leadInfo.data[0]?.name;
            setLeadName(name);

            const city = leadInfo.data[0]?.city;
            setLeadCity(city);

            const fullAddress = leadInfo.data[0]?.full_address;
            setLeadAddress(fullAddress);

            // console.log("lead info - ", leadInfo?.data);
         } 
        
      }, [leadInfo]); 


    const getApplicationDetailsData = async (action='',notes='') => {

        let actionStatus = '0';
        let submitStatus =  true;
         
        if(action ==='approve'){
            actionStatus = '1';
            if(notes ===''){
                toast.error("Notes is required.", {
                    position: "top-right",
                });
                submitStatus =  false;
            }
        }else if(action ==='reject'){
            actionStatus = '2';
    
              if(notes ===''){
                  toast.error("Notes is required.", {
                      position: "top-right",
                  });
                  submitStatus =  false;
              }
            }else if(action ==='reversal'){
                actionStatus = '3';
        
                  if(notes ===''){
                      toast.error("Notes is required.", {
                          position: "top-right",
                      });
                      submitStatus =  false;
                  }      

            } 
            
            if(submitStatus){
            if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);
            let readyToSubmit = true;

            const additionalDetails = { "religionsRows" : religionsRows, "categoryRows" : categoryRows , "preferredLanguageRows" : preferredLanguageRows, "motherNameRows" : motherNameRows , "alternateMobileRows" : alternateMobileRows , "parmanentAddressRows" : parmanentAddressRows , "noOfDependentsRows" : noOfDependentsRows , "educationalBackgroundRows" : educationalBackgroundRows , "educationDetailsRows" : educationDetailsRows} 
 

            let obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id),"action_status":actionStatus,'notes' :notes,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails, version_idd : selectionVersioningID };
            if(enableUpdatePdfDetails){
                
                if(refNo === ''){
                  /*  toast.error("Ref No is required.", {
                        position: "top-right",
                    });
                    readyToSubmit = false; */
                    readyToSubmit = true;
                } else if( sourceDealerDetails === '' ){
                  /*  toast.error("Source dealer details is required.", {
                        position: "top-right",
                    });
                    readyToSubmit = false; */
                    readyToSubmit = true;
                }   
                
                obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), "enableUpdatePdfDetails" : enableUpdatePdfDetails ,"action_status":actionStatus,'notes' :notes,"sendEmail" : sendEmailBtnAction,"additionalDetails":additionalDetails , version_idd : selectionVersioningID}; 
            } 

            if(readyToSubmit) {
                // console.log("obj lead id- ", obj);
                const requestData = encryptData(obj);
                const response = actions.getApplicationDetailsData(requestData);

                response.then((result) => {
                    setOpenRejectAmt(false);
                    setApproveBtnAction(0);
                    setSendEmailBtnAction(0);
                    // console.log("Promise resolved -  source data:", result); 
                    if (result.data.success === 1) {
                        const resultArr = result.data.data;

                       const allDealersMasters = resultArr?.all_dealers || [];
                        setAllDealers(allDealersMasters);

                        const allReligionsMasters = resultArr?.all_religions || [];
                        setAllReligions(allReligionsMasters); 
                        
                        const allSocialCategoryMasters = resultArr?.all_social_category || [];
                        setAllSocialCategory(allSocialCategoryMasters); 

                        const allPreferredLanguageMasters = resultArr?.all_preferred_language || [];
                        setAllPreferredLanguage(allPreferredLanguageMasters); 
                        
                        
                        const sanctionDetailsInfoInfo = resultArr?.latestSanctionDOEntryRow;
                        setSavedSanctionDetailsInfo(sanctionDetailsInfoInfo);
                         
                        const applicationDetailsInfo = resultArr?.latestApplicationDetailsRowInfo;
                        setSavedApplicationDetailsInfo(applicationDetailsInfo); 


                         
                       
                        if(applicationDetailsInfo !== null ){ 
                            console.log("111111111 applicationDetailsInfo?.resultArr = ", applicationDetailsInfo);
                           
                        if(applicationDetailsInfo?.additionalDetails){
                            console.log("222222 applicationDetailsInfo?.resultArr = ", applicationDetailsInfo?.additionalDetails);
                            const parsedData = JSON.parse(applicationDetailsInfo?.additionalDetails);
                            
                            if(parsedData?.religionsRows !== '' && parsedData?.religionsRows !== undefined) {
                                setReligionsRows(parsedData?.religionsRows);
                            }

                            if(parsedData?.categoryRows !== '' && parsedData?.categoryRows !== undefined) {
                                setCategoryRows(parsedData?.categoryRows);
                            }

                            if(parsedData?.motherNameRows !== '' && parsedData?.motherNameRows !== undefined) {
                                setMotherNameRows(parsedData?.motherNameRows);
                            }

                            if(parsedData?.preferredLanguageRows !== '' && parsedData?.preferredLanguageRows !== undefined) {
                                setPreferredLanguageRows(parsedData?.preferredLanguageRows);
                            }

                            if(parsedData?.alternateMobileRows !== '' && parsedData?.alternateMobileRows !== undefined) {
                                setAlternateMobileRows(parsedData?.alternateMobileRows);
                            }

                            if(parsedData?.educationDetailsRows !== '' && parsedData?.educationDetailsRows !== undefined) { 
                                setEducationDetailsRows(parsedData?.educationDetailsRows);
                            }

                            if(parsedData?.educationalBackgroundRows !== '' && parsedData?.educationalBackgroundRows !== undefined) {
                                setEducationalBackgroundRows(parsedData?.educationalBackgroundRows);
                            }

                            if(parsedData?.parmanentAddressRows !== '' && parsedData?.parmanentAddressRows !== undefined) {
                                setParmanentAddressRows(parsedData?.parmanentAddressRows);
                            }

                            if(parsedData?.noOfDependentsRows !== '' && parsedData?.noOfDependentsRows !== undefined) {
                                setNoOfDependentsRows(parsedData?.noOfDependentsRows);
                            }
                                
                        }   
                        }  
                        if(enableUpdatePdfDetails){
                            setEnableUpdatePdfDetails(false); 
                        }

                        const leadMoreDocumentsVal = resultArr?.lead_more_documents;
                        setLeadMoreDocuments(leadMoreDocumentsVal);
                    }

                    getCAMDetailsData();
                }).catch((error) => {
                    //  console.error("Promise rejected -  source data :", error); 
                });
            }
        }
    }
     
    };

    function calculateIRR(cashFlows, guess = 0.1) {
        const maxIteration = 1000;
        const precision = 1e-7;
        let rate = guess;

        for (let iter = 0; iter < maxIteration; iter+=1) {
            let npv = 0;
            let derivative = 0;

            for (let t = 0; t < cashFlows.length; t+=1) {
            npv += cashFlows[t] / (1 + rate) ** t;
            derivative -= t * cashFlows[t] / (1 + rate) ** (t + 1);
            }

            const newRate = rate - npv / derivative;

            if (Math.abs(newRate - rate) < precision) {
            return newRate;
            }

            rate = newRate;
        }

        throw new Error("IRR calculation did not converge");
        }

    const getCAMDetailsData = async () => {
        if (!id) {
          console.error("Error: ID is undefined.");
          return;
        }
      
        try {
          const decodedId = atob(id);
           
          const obj = {
            start: '0',
            length: config.MAX_RECORDS,
            lead_id: decodedId,
            with_additional_info:'yes',
            api_calling_module : "application_details",
            version_idd : selectionVersioningID
          };  
       
          setCoapplicantGuarantorRows(addedLeadCoapplicantGuarantorRows);
         //  console.log("4444 coapplicantGuarantorDetails = ",addedLeadCoapplicantGuarantorRows);                
          const requestData = encryptData(obj);
          const result = await actions.getCAMDetails(requestData);
      
          if (result?.data?.success === 1) {
            const results = result.data.data?.data || {};
            const resultArr = Object.values(results);
            
            if (resultArr?.length > 0 && resultArr[0]?.cam_details) {
                const camDetails = resultArr[0].cam_details; 
                const jsonData = JSON.parse(camDetails);  
                
                if (jsonData?.dob === '0000-00-00') {
                  jsonData.dob = '';
                }
                
                setCamDetails(jsonData); 

                 
                  if(savedSanctionDetailsInfo?.id !== undefined) { 
                    const latestSanctionDOEntryRow = (savedSanctionDetailsInfo?.additionalDODetails!== undefined && savedSanctionDetailsInfo?.additionalDODetails!== '') ? JSON.parse(savedSanctionDetailsInfo?.additionalDODetails) : [];
                     if(latestSanctionDOEntryRow?.dearlerSubventionDedcuteAmount ){
                        setDearlerSubventionDedcuteAmount(latestSanctionDOEntryRow?.dearlerSubventionDedcuteAmount);
                    }
                   // console.log("latestSanctionDOEntryRow = ", latestSanctionDOEntryRow); 
                 }
                


                if(jsonData?.cam_dealer_name !== ''){ 
                        const dealerInfo = allDealers.find(doc => doc.name === jsonData?.cam_dealer_name);
                        // setRefDoNo(event.target.value);
                        setDealerAddress(dealerInfo?.address);
                        setDealerBankName(dealerInfo?.bank_name);
                        setDealerAccountNo(dealerInfo?.account_no);
                        setDealerIfsc(dealerInfo?.ifsc);
                        setDealerBenificaryName(dealerInfo?.benificary_name); 
                        setDealerName(dealerInfo?.name);
                    }


                 let gstAmount = 0;
                 if(jsonData?.dmemo_processing_fee_including_gst !== ''){
                   gstAmount = (jsonData?.dmemo_processing_fee_including_gst * 18) / 100; 
                  }

                setAmountOfProcessingFee(roundNumber(gstAmount));

                const tenure = sLTenure;  // 10;  
                const emiAmt =  emiAllVehicle; // 10987.73; // Monthly EMI
                const disbursement =  netDisbursementAmt; // 97097.26 // Net Disbursement

               /* alert(tenure);
                alert(emi);
                alert(disbursement); */
               // const apr = calculateAPR(tenure, emiAmt, disbursement);
               // setAprValue(apr);

                const financeAmount = jsonData?.irr_finance_amount || 0;
                const processingFeeVal = jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst;

                const emi = emiAmt;
                const tenureMonths = sLTenure;
                const processingFee = (Number(financeAmount) * processingFeeVal) /100;
                const loanAmount = jsonData?.irr_finance_amount || 0;
                const disbursedAmount = loanAmount - processingFee;

                const cashFlows = [-disbursedAmount];
                for (let i = 1; i <= tenureMonths; i+=1) {
                cashFlows.push(emi);
                }

                let result = 0;
                try {
                const irrMonthly = 0;// calculateIRR(cashFlows);
                result = irrMonthly * 12 * 100; // monthly to annual APR
               // console.log("APR:", result.toFixed(2) + "%");
                } catch (err) {
                     console.error("IRR calculation failed monthly to annual APR :", err);
                } 

                setAprValue(result.toFixed(2));

                if(jsonData?.dmemo_reference_no !==''){
                    setRefNo(jsonData?.dmemo_reference_no);
                }

                if(jsonData?.dmemo_pre_emi_end_date !==''){                    
                    setLessPreEmiTill5thLabel(`Less: Pre-EMI Till 5TH ${formatOnlyMonthYearValue(jsonData?.dmemo_pre_emi_end_date)}`);
                }
                 
                if (jsonData?.coapplicantGuarantorDetails !=='') {
                  setCoapplicantGuarantorRows(jsonData.coapplicantGuarantorDetails);
                 // setAddedLeadCoapplicantGuarantorRows  
                 }  

               
                 if(savedApplicationDetailsInfo?.id === undefined) { 
                    
                    // for null
                    setExShowroomPriceValue(jsonData?.dmemo_invoice_price_per_vehicle);
                    setInsuranceAmounByDealerValue(jsonData?.assets_insurance_by_dealer);  
                    setTotalOnRoadPriceValue(jsonData?.dmemo_total_cost_per_vehicle);
                    
                    setLoanAmountValue(jsonData?.dmemo_funding_per_vehicle); 
                    setProcessingFeeOnFinanceAmountPlusGSTValue(jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst);
                    setLessProcessingFeeIncludingGSTValue(jsonData?.dmemo_processing_fee_including_gst);
                    setLessInsuranceByKotakMahindraValue(jsonData?.cam_kotak_li_amount);
                    setLessPreEmiTill5THJanValue(jsonData?.dmemo_less_pre_emi_till_5th_jan);
                    setFileChargeValue(jsonData?.cam_file_charges);
                    setNetDisbursementValue(jsonData?.dmemo_net_disbursement);
                    setNameOfSupplierDealerValue(jsonData?.cam_dealer_name);

                    setAssetValueVehicleVehiclesValue(jsonData?.dmemo_invoice_price_all_vehicle);
                    setNoOfAssetValue(jsonData?.dmemo_no_of_asset);

                    setTotalDownPaymentByCustomerValue(jsonData?.dmemo_total_down_payment_by_customer);
                    
                } 
                
                
                const processingFeeIncludingGst = Number(jsonData?.dmemo_processing_fee_including_gst) || 0;
                const processingFeeExcludingGSTAmt = (Number(processingFeeIncludingGst) - Number(amountOfProcessingFee)).toFixed(2);
                setLessProcessingFeeExcludingGST(processingFeeExcludingGSTAmt);

                const sanctionAmt = jsonData?.dmemo_funding_per_vehicle || 0;
                const processingFeePer = jsonData?.dmemo_processing_fee_on_finance_amount_plus_gst || 0;
                
                const feeChargesPayableAmt = roundNumber((Number(sanctionAmt) * Number(processingFeePer) / 100)).toFixed(2);  
                setFeeChargesPayable(feeChargesPayableAmt);

                const insuranceByCfplAmount = 0;
                let totalMarginMoneyReceiptAmtount = Number(jsonData?.irr_total_asset_price) || 0; 

                let totalNetDisbursementAmount = Number(jsonData?.dmemo_disbursement_amount_for_vehicle_including_box) || 0;                
                 
                let totalMarginMoneyReceiptRequired = 0;
                if (jsonData?.dmemo_margin_money_all_vehicle !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_margin_money_all_vehicle) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_margin_money_all_vehicle) || 0;
                }
               /* if (processingFeeExcludingGSTAmt !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(processingFeeExcludingGSTAmt) || 0;
                    totalMarginMoneyReceiptRequired += Number(processingFeeExcludingGSTAmt) || 0;
                } */

                 if (feeChargesPayableAmt !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(feeChargesPayableAmt) || 0;
                    totalMarginMoneyReceiptRequired += Number(feeChargesPayableAmt) || 0;
                }

                if (gstAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(gstAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(gstAmount) || 0;
                }
                if (dearlerSubventionDedcuteAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(dearlerSubventionDedcuteAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(dearlerSubventionDedcuteAmount) || 0;
                     totalNetDisbursementAmount -= Number(dearlerSubventionDedcuteAmount) || 0;
                }

                 
                if (insuranceByCfplAmount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(insuranceByCfplAmount) || 0;
                     totalMarginMoneyReceiptRequired += Number(insuranceByCfplAmount) || 0;
                    // totalNetDisbursementAmount -= Number(insuranceByCfplAmount) || 0;
                }  

                if (jsonData?.dmemo_pre_emi !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_pre_emi) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_pre_emi) || 0;
                }
                if (jsonData?.dmemo_file_charge !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_file_charge) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_file_charge) || 0;
                }
                if (jsonData?.dmemo_kli_amount !== '') {
                    totalMarginMoneyReceiptAmtount -= Number(jsonData?.dmemo_kli_amount) || 0;
                    totalMarginMoneyReceiptRequired += Number(jsonData?.dmemo_kli_amount) || 0;
                }
 
               

                setTotalMarginMoneyReceiptAmt(totalMarginMoneyReceiptRequired.toFixed(2));
               // setNetDisbursementAmt(totalMarginMoneyReceiptAmtount.toFixed(2));

                 setNetDisbursementAmt(totalNetDisbursementAmount.toFixed(2));
               
                 setEmiAllVehicle((Number(jsonData?.dmemo_emi_all_vehicle) || 0).toFixed(2));
                 setSLTenure(Number(jsonData?.dmemo_tenure) || 0);

                setIsReadyToModify(resultArr[0]?._isReadyToModify);
                
                setLoanAmountSchedule(jsonData?.dmemo_funding_per_vehicle);
                setInterestRateSchedule(jsonData?.dmemo_irr); 
                setLoanDurationSchedule(sLTenure);
                setPaymentsPerYearSchedule(Number(jsonData?.dmemo_tenure) || 0);     
            }
    
            const crifDetailsMaster = resultArr[0]?.additional_info?.crif_details || [];
            setCrifDetails(crifDetailsMaster);
    
            const bankDetailsMaster = resultArr[0]?.additional_info?.banking_details || [];
            setBankDetails(bankDetailsMaster);
    
            const camApprovalHistoryInfo = resultArr[0]?.additional_info?.cam_approval_history || [];
            setCamApprovalHistory(camApprovalHistoryInfo);  
    
            const anchorCategoryMaster = resultArr[0]?.additional_info?.anchor_category_master || [];
            setAnchorCategories(anchorCategoryMaster);
    
            const speciallyAbledMaster = resultArr[0]?.additional_info?.specially_abled || [];
            setSpeciallyAbledArr(speciallyAbledMaster);
    
            const residenceTypesMaster = resultArr[0]?.additional_info?.residence_types || [];
            setResidenceTypesArr(residenceTypesMaster);
    
            const bankingUpiMaster = resultArr[0]?.additional_info?.banking_upis || [];
            setBankingUpiArr(bankingUpiMaster);
    
            const constitutionMaster = resultArr[0]?.additional_info?.constitutions || [];
            setConstitutionArr(constitutionMaster);
    
            const customerTypeMaster = resultArr[0]?.additional_info?.customer_type || [];
            setCustomerTypeArr(customerTypeMaster);
    
            const vehicleMakerMaster = resultArr[0]?.additional_info?.vehicle_maker || [];
            setVehicleMakerArr(vehicleMakerMaster);
    
            const vehicleUseMaster = resultArr[0]?.additional_info?.vehicle_use || [];
            setVehicleUseArr(vehicleUseMaster);
    
            const insuranceMaster = resultArr[0]?.additional_info?.insurance || [];
            setInsuranceArr(insuranceMaster);
    
            const vehicleModelsMaster = resultArr[0]?.additional_info?.vehicle_models || [];
            setVehicleModelsArr(vehicleModelsMaster);
    
            const businessValidationProofMaster = resultArr[0]?.additional_info?.business_validation_proof || [];
            setBusinessValidationProofArr(businessValidationProofMaster);
    
            const turnoverIncomeMaster = resultArr[0]?.additional_info?.turnover_income || [];
            setTurnoverIncomeArr(turnoverIncomeMaster);
    
            const workingCapitalCycleMaster = resultArr[0]?.additional_info?.working_capital_cycle || [];
            setWorkingCapitalCycleArr(workingCapitalCycleMaster);
    
            const accountTypeMaster = resultArr[0]?.additional_info?.account_type_master || [];
            setAccountTypeArr(accountTypeMaster);
             
          } 
        } catch (error) {
         // console.error("Error in getCAMDetailsData:", error);
        }
      };

    const getUploadLeadDocumentData = async () => {
        if (id !== undefined) {
            setPropLeadId(atob(id));
            setLeadId(propLeadId);

            const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": atob(id), 'api_calling_module' : "sanction_module" };
            // console.log("obj lead id- ", obj);
            const requestData = encryptData(obj);
            const response = actions.getUploadLeadDocument(requestData);

            response.then((result) => {
                // console.log("Promise resolved -  source data:", result); 
                if (result.data.success === 1) {
                    const results = result.data.data.data;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    setAllUploadLeadDocument(resultArr);
                }
            }).catch((error) => {
                //  console.error("Promise rejected -  source data :", error); 
            });
        }
    };

    useEffect(() => {
        if (isActive) { 
            getApplicationDetailsData();
          //  getUploadLeadDocumentData();
            if (leadInfo?.data?.length > 0) {

                 const leadDetailsVal = leadInfo.data[0];
                 setLeadDetails(leadDetailsVal);

                 // get lead assigned checklists
                 const checkListsResults = leadDetailsVal?.all_checklists || [];
                 const checkListsResultsArr = Object.keys(checkListsResults).map(
                     (key) => checkListsResults[key]
                 );
                 setAllLeadCheckLists(checkListsResultsArr);


                const name = leadInfo.data[0]?.name;
                setLeadName(name);

                const city = leadInfo.data[0]?.city;
                setLeadCity(city);

                const fullAddress = leadInfo.data[0]?.full_address;
                setLeadAddress(fullAddress);

                console.log("lead info - ", leadInfo?.data);

                const allLeadDocuments = leadInfo.data[0]?.lead_document;
                setAllLeadDocumentsArr(allLeadDocuments);

                
                const addedAllCoApplicantsVal = leadInfo.data[0]?.lead_co_applicants || [];
                const activeCoApplicants = addedAllCoApplicantsVal.filter(
                (item) => item.status === '1'
                );
                setAddedAllCoApplicants(activeCoApplicants); 
 
                
                const addedAllGuarantorsVal = leadInfo.data[0]?.lead_guarantors || [];
                const activeGuarantors = addedAllGuarantorsVal.filter(
                (item) => item.status === '1'
                );
                setAddedAllGuarantors(activeGuarantors); 
               // alert('here')

               let totalColspan = 2;
                if (Array.isArray(activeCoApplicants) && activeCoApplicants.length > 0) {
                    totalColspan += activeCoApplicants.length;
                }
                if (Array.isArray(activeGuarantors) && activeGuarantors.length > 0) {
                    totalColspan += activeGuarantors.length;
                } 

                setVerticalTotalColspan(totalColspan);

                const leadMoreDocumentsVal = leadInfo.data[0]?.lead_more_documents;
                setLeadMoreDocuments(leadMoreDocumentsVal);
                
            } 
           getCAMDetailsData(); // added new code line
           
        }
    }, [isActive]);

    /* useEffect(() => {
         if (id !== undefined) {
             getUploadLeadDocumentData(); 
         }
 
     }, [setAllUploadLeadDocument]); */

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.masterDocumentTypeData(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  source data:", result); 
            if (result.data.success === 1) {
                const results = result.data.data.data
                const filteredResultArr = results.filter((item) => item.status === "1");
                const sortedResultArr = filteredResultArr.sort((a, b) =>
                    a.document_type.localeCompare(b.document_type)
                );
                setAllDocumentTypeData(sortedResultArr);
            }
        }).catch((error) => {
            //  console.error("Promise rejected -  source data :", error); 
        });

    }, [setAllDocumentTypeData]);

    const handleDocumentFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedDocumentFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const onSubmit = (data) => {

        setPropLeadId(atob(id));
        setLeadId(propLeadId);

        if (data.document_type.trim() === "") {
            toast.error("No document type has been selected.", {
                position: "top-right",
            });
        } else if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else if (data.document_note.trim() === "") {
            toast.error("Note is blank.", {
                position: "top-right",
            });
        } else {

            const params = { "lead_id": propLeadId, "document_type": data.document_type, "document_note": data.document_note, "document_file": selectedDocumentFiles };

            const requestData = encryptData(params);
            const response = actions.addEditLeadDocument(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - addEditLeadDocument form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });

                    const obj = { 'start': '0', 'length': config.MAX_RECORDS, "lead_id": propLeadId };
                    // console.log("obj lead id- ", obj);
                    const requestData = encryptData(obj);
                    const response = actions.getUploadLeadDocument(requestData);

                    response.then((result) => {
                        // console.log("Promise resolved -  source data:", result); 
                        if (result.data.success === 1) {
                            const results = result.data.data.data;
                            const resultArr = Object.keys(results).map((key) => results[key]);
                            setAllUploadLeadDocument(resultArr);
                        }
                    }).catch((error) => {
                        //  console.error("Promise rejected -  source data :", error); 
                    });

                    reset();
                    setSelectedDocumentFiles("");
                    props.updateParentState(false);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const filteredItems = (allUploadLeadDocument ?? []).filter(item =>
        item.formatetdID.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.assignedUser.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.statusName.toLowerCase().includes(searchQuery.toLowerCase())
    );


    const startIndex = (currentPage - 1) * config.ITEMS_PER_PAGE;
    const endIndex = startIndex + config.ITEMS_PER_PAGE;
    const paginatedItems = filteredItems.slice(startIndex, endIndex);
    const totalPages = Math.ceil(filteredItems.length / config.ITEMS_PER_PAGE);

    const onRowClickAction = (itemObj, btnAction) => {
        setViewModalInfo(itemObj);
        setOpen(true);
    }

    const veridateDoc = (data, actionStatus) => {

        const verifyDocStatus = (actionStatus) ? 1 : 0;
        const params = { "id": data.id, "status": verifyDocStatus };

        const requestData = encryptData(params);
        const response = actions.verifyDocuments(requestData);
        response.then((result) => {
            if (result.data.success === 1) {
                toast.success(result.data.message, {
                    position: "top-right",
                });
                getUploadLeadDocumentData();
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
            toast.error(error, {
                position: "top-right",
            });
        });
    };

    const handleNoBank = (event, item) => {
        setIsVerifyDocChecked(event.target.checked)
        veridateDoc(item, event.target.checked);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleToggle = (action) =>{

        if(action !==''){
            setApplicationDetailsFormActiveTab(action);
            setApplicationDetailsFormStatus(true);
        }else{
             setApplicationDetailsFormStatus(prevState => !prevState); 
        }
        getApplicationDetailsData();
    }

    const handleToggleUpdateDetails = () =>{
        setEnableUpdatePdfDetails(prevState => !prevState); 
    }

    const handleToggleSaveDetails = () =>{ 
        getApplicationDetailsData();
    }

    const handleSourceDealerChange = (event) =>{
          setSourceDealerDetails(event.target.value);
    }

    const handleFormChange = (event) =>{
        if(event.target.name ==='refNo'){
             setRefNo(event.target.value);
        }
        if(event.target.name ==='insuranceFor'){
            setInsuranceFor(event.target.value); 
            if(event.target.value === ''){
                setInsuranceFor('For insurance by ckers');
            } 
         }
        if(event.target.name ==='dealerSubvention'){
            setDealerSubvention(event.target.value);
            if(event.target.value === ''){
                setDealerSubvention('Dealer Subvention');
            }
        }

        if(event.target.name ==='loanAmountValue'){
            setLoanAmountValue(event.target.value); 
        }

        if(event.target.name ==='processingFeeOnFinanceAmountPlusGSTValue'){
            setProcessingFeeOnFinanceAmountPlusGSTValue(event.target.value); 
        }

        if(event.target.name ==='lessProcessingFeeIncludingGSTValue'){
            setLessProcessingFeeIncludingGSTValue(event.target.value); 
        }

        if(event.target.name ==='lessInsuranceByKotakMahindraValue'){
            setLessInsuranceByKotakMahindraValue(event.target.value); 
        }

        if(event.target.name ==='lessPreEmiTill5THJanValue'){
            setLessPreEmiTill5THJanValue(event.target.value); 
        }

        if(event.target.name ==='fileChargeValue'){
            setFileChargeValue(event.target.value); 
        }

        if(event.target.name ==='netDisbursementValue'){
            setNetDisbursementValue(event.target.value); 
        }

        if(event.target.name ==='nameOfSupplierDealerValue'){
            setNameOfSupplierDealerValue(event.target.value); 
        }

        if(event.target.name ==='exShowroomPriceValue'){
            setExShowroomPriceValue(event.target.value); 
        }

        if(event.target.name ==='assetValueVehicleVehiclesValue'){
            setAssetValueVehicleVehiclesValue(event.target.value); 
        }

        if(event.target.name ==='noOfAssetValue'){
            setNoOfAssetValue(event.target.value); 
        }

        if(event.target.name ==='insuranceAmounByDealerValue'){
            setInsuranceAmounByDealerValue(event.target.value); 
        }

        if(event.target.name ==='totalOnRoadPriceValue'){
            setTotalOnRoadPriceValue(event.target.value); 
        }
 
 
        if(event.target.name ==='insuranceForValue'){
            setInsuranceForValue(event.target.value); 
        }

        if(event.target.name ==='dealerSubventionValue'){
            setDealerSubventionValue(event.target.value); 
        }
         
         
    }

    const [htmlContent, setHtmlContent] = useState('');
    const editorRef = useRef(null);
    

    const handleInput = () => {
        setHtmlContent(editorRef.current.innerHTML);
    };

    const [formRejectitem, setFormRejectitem] = useState({
      notes: '',
    });

    const btnOpenRejectData = (approveBtnAction,sendEmail='0') => {    // buttonFun 
        setApproveBtnAction(approveBtnAction);
        setOpenRejectAmt(true);
        setSendEmailBtnAction(sendEmail);
    };

    const handleCloseRejectAmt = () => {     // Modal onclick closedFun
        setApproveBtnAction(0);
        setOpenRejectAmt(false);
        setSendEmailBtnAction(0);
       };

       const handleRejectFormSubmit = (data) => {
         if (data.notes === '') {
           toast.error("Notes is required.", {
             position: "top-right",
           });
         } else { 
           
              if(approveBtnAction === '1'){
                // getApplicationDetailsData('approve',data.notes);
             }
             
             if(approveBtnAction === '2'){
                // getApplicationDetailsData('reject',data.notes);
             }

             if(approveBtnAction === '3'){
               // getApplicationDetailsData('reversal',data.notes);
            }
         }
        }

        const handleAmtRejectChange = (e) => {
            const totalAmt = e.target.value;
            setFormRejectitem((prevState) => ({
              ...prevState,
              totalAmt,
            }));
          }

        const printRef = useRef();
        const handleDownloadPdf = async () => {
            const element = printRef.current;
            if (!element) {
                console.error('Printable element not found');
                return;
            }

            setPreloaderStatus(true);

            /* ---------- 1. Render the DOM node to a single canvas ---------- */
            const canvas = await html2canvas(element, {
                scale   : 1,          // lower scale → smaller PDF, still readable on A4
                useCORS : true,       // remote images must have Access‑Control‑Allow‑Origin
                allowTaint: false,
                scrollY : -window.scrollY
            });

            /* ---------- 2. Prepare jsPDF ---------- */
            const pdf       = new JsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
            const pdfW      = pdf.internal.pageSize.getWidth();
            const pdfH      = pdf.internal.pageSize.getHeight();
            const imgW      = pdfW;
            const imgH      = (canvas.height * pdfW) / canvas.width;      // keep aspect ratio
            const pagePxH   = Math.floor((canvas.width * pdfH) / pdfW);   // canvas pixels per PDF page
            const pages     = Math.ceil(canvas.height / pagePxH);

            /* ---------- 3. Re‑use ONE off‑screen canvas for all page slices ---------- */
            const pageCanvas        = document.createElement('canvas');
            pageCanvas.width        = canvas.width;
            const pageCtx           = pageCanvas.getContext('2d');

            /* ---------- 4. Loop over pages ---------- */
            for (let page = 0; page < pages; page += 1) {
                const startY  = page * pagePxH;
                const sliceH  = Math.min(pagePxH, canvas.height - startY);

                // resize helper canvas only when height changes (last page)
                if (pageCanvas.height !== sliceH) { pageCanvas.height = sliceH; }
 
                pageCtx.clearRect(0, 0, canvas.width, sliceH);
                pageCtx.drawImage(canvas, 0, startY, canvas.width, sliceH, 0, 0, canvas.width, sliceH);
                const imgData = pageCanvas.toDataURL('image/jpeg', 0.7);

                // add to PDF
                if (page > 0) pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, 0, imgW, (sliceH * pdfW) / canvas.width);
            }

            /* ---------- 5. Build filename & save ---------- */
            const ts = new Date().toISOString().replace(/[:.]/g, '-');
            const prefix =
                applicationDetailsFormActiveTab === 'schedule_a'
                ? 'schedule_a'
                : applicationDetailsFormActiveTab === 'drf'
                    ? 'drf'
                    : 'application_details';

            pdf.save(`${prefix}_${ts}.pdf`);
            setPreloaderStatus(false);
            };


    const toggleSection = (tabName) => {

      //  alert(tabName);

        if (tabName === 'FI') {
            setIsFIOpen(!isFIOpen);
        }

        if (tabName === 'Miscellaneous Documents') {
            setIsMiscOpen(!isMiscOpen);
        }

        if (tabName === 'Applicant Documents') {
            setIsApplicantOpen(!isApplicantOpen);
        }

        if (tabName === 'Co-Applicant Documents') {
            setIsCoApplicantOpen(!isCoApplicantOpen);
        }

        if (tabName === 'Guarantor Documents') {
            setIsGuarantorOpen(!isGuarantorOpen);
        }
    };


   const getLastDueDate = (startDate, tenureMonths) => {
        if (!startDate || !tenureMonths) return '';
        const date = new Date(startDate);
        date.setMonth(date.getMonth() + tenureMonths - 1);

        // Format as YYYY-MM-DD
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');

        return `${yyyy}-${mm}-${dd}`;
        };

    return (
        <>
<div id="main-wrap" className='mt-4'>
<div className='row justify-content-between'>
<h5 className="fw-bold">Application Details</h5>

{(userRoleType !== "" || userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin' || userRoleType === 'Credit Head' || userRoleType === 'Credit Operations') && (
<div className="col-md-12 mb-3">

     {applicationDetailsFormStatus && (
        <>
        <button type="button" className={
                      applicationDetailsFormActiveTab === "application_details" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('application_details')}  title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         Application Details
         </button>  
        &nbsp; <button type="button" className={
                      applicationDetailsFormActiveTab === "schedule_a" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('schedule_a')} 
         title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         Schedule A
         </button> 
         &nbsp; <button type="button" className={
                      applicationDetailsFormActiveTab === "drf" 
                        ? "btn btn-success text-white"
                        : "btn btn-default text-white"
                    } onClick={() => handleToggle('drf')} 
         title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
         DRF
         </button>&nbsp;&nbsp;
        </>
    )}

    <button type="button" className="btn btn-primary text-white d-none" onClick={handleToggle}  title="Visible To : Credit , Manager , Credit Head and Superadmin Users" >
    {applicationDetailsFormStatus ? 'Go Back' : 'Show Application Details'}
    </button>
 

    {(  (userRoleType === "Credit" ||  userRoleType === 'Superadmin') ) && (
     <button type="button" className="btn btn-warning text-white float-right d-none" onClick={clickCcmTab} title="Visible To : Credit and Superadmin Users" >
      { isReadyToModify ? "Update Sanction Terms Details" : "Sanction Terms Details" }
    </button>
    )} 

    
</div> 
)} 

<div className=""> 

{ ( !applicationDetailsFormStatus) ?(<>
<div className='row'>
{activeAccordionSections.map((sectionInfo, sectionIndex) => {
    const matchingDocs = activeAllSancationDocs.filter(
        (doc) => doc.doc_section === sectionInfo
    );
    let isOpenSection = false;
    if (sectionInfo === 'Miscellaneous Documents') {        
        isOpenSection = isMiscOpen;
    }

    if (sectionInfo === 'Applicant Documents') {
         isOpenSection = isApplicantOpen;
    }

    if (sectionInfo === 'Co-Applicant Documents') {
         isOpenSection = isCoApplicantOpen;
    }

    if (sectionInfo === 'Guarantor Documents') {
         isOpenSection = isGuarantorOpen;
    }

    return (
        <div key={sectionIndex} className="col-md-12">
            <div className="collapsible-section">

                <button
                    className="section-header"
                    onClick={() => toggleSection(sectionInfo)}
                >
                    <h5>{sectionInfo}</h5>
                    <span>{isFIOpen ? '-' : '+'}</span>
                </button> 
                {isOpenSection && (
                    <div className="section-content">
                        {matchingDocs.map((docInfo, index) => {
                            // Find the matching document in allUploadLeadDocument
                            const matchedDoc = allUploadLeadDocument.find((item) => item.documentTypeName === docInfo.doc_name);

                            return (
                                <div key={index} className="col-md-12 mb-2">

                                    <b>{docInfo.doc_name}</b>
                                    {matchedDoc ? (
                                        <>
                                           
                                            { (matchedDoc.document !=='') && (
                                             <>   
                                            &nbsp; -  &nbsp;
                                            <a target="new" href={matchedDoc.document} className="text-decoration-none">
                                                Download File
                                            </a>
                                            &nbsp; Uploaded On {matchedDoc.created_date} by {matchedDoc.createdByName}
                                            </>
                                            ) }

                                            {matchedDoc.verified_status !== "1" ? (
                                                <>
                                                    &nbsp;- <span className="text-danger">NOT VERIFIED</span>
                                                </>
                                            ) : (

                                                <>
                                                    &nbsp; - <span className='text-green'>Validated On</span> {matchedDoc.validated_date} by {matchedDoc.validatedByName}
                                                </>
                                            )}


                                            {(userRoleType === "Credit" || userRoleType === "Manager" || userRoleType === 'Superadmin') && (
                                                <>
                                                    {(matchedDoc.documentTypeStatus === 'dynamic') ?
                                                        (
                                                            <>
                                                                <span className='float-right'>
                                                                    {matchedDoc.verified_status !== '1' ? (
                                                                        <>
                                                                            {(matchedDoc.notMatchingDetails !== '') ? JSON.parse(matchedDoc.notMatchingDetails) : ''}
                                                                        </>
                                                                    ) : (
                                                                        <>&nbsp;</>
                                                                    )}
                                                                </span>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {matchedDoc.verified_status !== '1' ? (
                                                                    <span className='float-right'>
                                                                        <input type='checkbox' name='document_verify' id='document_verify'
                                                                            {...register('document_verify')}
                                                                            onChange={(event) => handleNoBank(event, matchedDoc)}
                                                                        /> <b>Verify</b></span>
                                                                ) : (
                                                                    <>&nbsp;</>
                                                                )}
                                                            </>
                                                        )}


                                                </>
                                            )}

                                        </>
                                    ) : (
                                        <>
                                            &nbsp;- <span className="text-danger">NOT UPLOADED</span>
                                        </>
                                    )}

                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
})} 

<div className="col-md-12">
    <div className="collapsible-section">
        <button
            className="section-header"
            onClick={() => toggleSection('FI')}
        >
            <h5>FI Details</h5>
            <span>{isFIOpen ? '-' : '+'}</span>
        </button>

        {isFIOpen && (
            <div className="section-content">
                {allLeadCheckLists.map((item, index) => (
                    <div key={index} className="col-md-12 mb-2">

                        <b>{item.check_list_name}</b> {(item.section_name !== '') && (<> (<span
                            className={
                                item.section_name === 'Lead'
                                    ? 'text-green'
                                    : item.section_name === 'Guarantor'
                                        ? 'text-primary'
                                        : 'text-warning'
                            }
                        >{(item.section_name === 'Lead') ? "Applicant" : item.section_name}</span> - {item.checklist_user_name})</>)}

                        {(item.fieldInvestigationFalg === '1') ? (
                            <>
                                &nbsp; - Verified by system
                            </>
                        ) : (
                            <>
                                &nbsp;- <span className="text-danger">NOT VERIFIED</span>
                            </>
                        )}

                    </div>
                ))}
            </div>)}
    </div>
</div>
</div>
</>) :

( 
 <>
     <div>
      <div className= "applicationDetailsClass" style={
                isReadyToModify
                ? { border: "1px solid grey", padding: "10px" }
                : { border: "1px solid grey", padding: "10px" }
            }>
  
      <div ref={printRef}>
            <div style={{ padding: "10px" }}>
            <div className={ applicationDetailsFormActiveTab === "application_details" ? "" : "d-none"}> 

                <div className="container-application_details">
                    <div className="box-application_details">&nbsp;</div>
                    <div className="box-application_details">&nbsp;</div>
                    <div className="box-application_details">&nbsp;</div>
                    <div className="box-application_details">&nbsp;</div>
                    <div className="box-application_details">&nbsp;</div>
                    <div className="box-application_details">&nbsp;</div>
                </div>
                Application Date:____/_______/_____<br/> 
            </div>
            <div style={{ textAlign: "center"}}>
            {(camDetails?.cam_lender ==='Vivriti') ? (
                    <>
                    <div style={{ textAlign: 'center' }}>
                        <img src="/assets/vivriti-logo.png" className="login-logo-" alt="Vivriti Logo" style={{  display: "inline"}} />
                        </div>
                        <h4> Vivriti Capital Limited</h4>
                        Prestige Zackria Metropolitan, No. 200/1-8, 2nd Floor, Block 1, Anna Salai, Chennai - 600002
                    </>
                 ) : (
                    <>
                   <div style={{ textAlign: 'center' }}>
                 <img src="/assets/ckern-logo.png" className="login-logo-" alt="CKers Logo" style={{  display: "inline"}} />
                </div>
                <h4> cKers Finance Private Limited</h4>
                Building No-24-30, First Floor, Okhla Industrial Area Phase - III, New Delhi 110020, India
                 </>
                 )}
                 </div>

            <div style={{ textAlign: "center"}}>
                <div style={{ paddingTop: '10px' }}>                 
                    {applicationDetailsFormActiveTab === "application_details" && (
                    <>
                      <h5>ELECTRICAL COMMERCIAL VEHICLE LOAN APPLICATION FORM</h5>FILL COMPLETELY IN ALL RESPECTS IN BLOCK LETTERS IN BLUE / BLACK PEN ONLY
                    </>
                    ) } 

                    {applicationDetailsFormActiveTab === "schedule_a" && (
                    <>
                      <h5>Schedule A</h5>
                    </>
                    ) } 

                    {applicationDetailsFormActiveTab === "drf" && (
                    <>
                      <h5>DISBURSAL REQUEST FORM</h5>
                    </>
                    ) } 
                </div>
            </div>
            { /* <div style={{ textAlign: "center"}}>&nbsp;</div>       
             Application Details section  :  START HERE */ }
            <div className={ applicationDetailsFormActiveTab === "application_details" ? "" : "d-none"}> 
                      <>
                        <div>&nbsp;</div>
                        <table style={{ border: '1px',width:'100%' }}>
                            <tr> 
                                <th style={{ borderWidth: '1px' }}>Customer Details</th>
                                <th style={{ borderWidth: '1px' }}>Entity:<br/>
                                                            Individual   [    ] / Non-Individual[  ] <br/>  
                                                            Applicant/ Borrower 
                                                            </th>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <th style={{ borderWidth: '1px' }}>
                                            Co-applicant [    ] <br/>
                                            Entity:<br/>
                                            Individual   [    ] / Non-Individual[  ]<br/>   
                                            Relationship with applicant : {row?.relationName}
                                        </th>
                                    ))}

                                    

                                   {addedAllGuarantors.map((row, index) => (
                                        <th style={{ borderWidth: '1px' }}> 
                                           
                                             {(() => {  
                                                
                                                 const rowInfoArr = coapplicantGuarantorRows.filter(item => item.id === `G${row.id}`); 
                                                const relationName = (rowInfoArr[0]?.relation !== undefined) ? rowInfoArr[0]?.relation .trim().split(/\s+/) : ''; 
                                                return (
                                                <>
                                                    Guarantor  [    ] <br/>
                                                    Entity:<br/>
                                                    Individual   [    ] / Non-Individual[  ]<br/>   
                                                    Relationship with applicant : {row?.relationName ? row.relationName : relationName}
                                                    </> 
                                                );
                                                })()}
                                        </th>
                                    ))} 
                            </tr>
                        
                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Name</td>
                                <td style={{ borderWidth: '1px' }}> 

                                   {(() => {
                                        const nameParts = (leadDetails?.name !== undefined) ? leadDetails?.name.trim().split(/\s+/) : '';
                                        let firstName = ""; 
                                        let middleName = ""; 
                                        let lastName = "";

                                        if (nameParts.length === 2) {
                                            [firstName, lastName] = nameParts;
                                        } else if (nameParts.length === 3) {
                                            [firstName, middleName, lastName] = nameParts;
                                        } else if (nameParts.length > 3) {
                                            firstName = nameParts[0];
                                            middleName = nameParts[1];
                                            lastName = nameParts.slice(2).join(" ");
                                        } else if (nameParts.length === 1) {
                                            firstName = nameParts[0];
                                        }
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{firstName}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{middleName}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{lastName}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
                                        const firstName = row?.first_name; 
                                        const middleName = ""; 
                                        const lastName = row?.last_name;
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{firstName}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{middleName}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{lastName}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           {(() => { 
                                        const firstName = row?.first_name; 
                                        const middleName = ""; 
                                        const lastName = row?.last_name;
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{firstName}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{middleName}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{lastName}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr>

                           
                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Gender</td>
                                <td style={{ borderWidth: '1px' }}>
                                   {(() => {  
                                     const genderVal = (camDetails?.cam_gender !== undefined && camDetails?.cam_gender !=='') ? camDetails?.cam_gender : '';                                      
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                     Male [{genderVal !== undefined && genderVal.toLowerCase() === 'male' ? (
                                                        <i className="nav-icon bi bi-check">&nbsp;</i>
                                                        ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    Female [{genderVal !== undefined && genderVal.toLowerCase() === 'female' ? (
                                                        <i className="nav-icon bi bi-check">&nbsp;</i>
                                                        ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    Third Gender [{genderVal !== undefined && genderVal.toLowerCase() === 'third gender' ? (
                                                        <i className="nav-icon bi bi-check">&nbsp;</i>
                                                        ) : (<>&nbsp;&nbsp;</>)}]</span>
                                            </div>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => {  
                                     const genderVal = (row?.gender !== undefined && row?.gender !=='') ? row?.gender : '';                                      
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                     Male [{genderVal !== undefined && genderVal.toLowerCase() === 'male' ? (
                                                        <i className="nav-icon bi bi-check">&nbsp;</i>
                                                        ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    Female [{genderVal !== undefined && genderVal.toLowerCase() === 'female' ? (
                                                        <i className="nav-icon bi bi-check">&nbsp;</i>
                                                        ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    Third Gender [{genderVal !== undefined && genderVal.toLowerCase() === 'third gender' ? (
                                                        <i className="nav-icon bi bi-check">&nbsp;</i>
                                                        ) : (<>&nbsp;&nbsp;</>)}]</span>
                                            </div>
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {  
                                         const genderVal = (row?.gender !== undefined && row?.gender !=='') ? row?.gender : '';                                       
                                            return ( 
                                                <div style={{ 
                                                    display: 'flex', 
                                                    justifyContent: 'space-between', 
                                                    alignItems: 'flex-end',  
                                                    height: '100%',
                                                    width:'100%'  
                                                }}>
                                                    <span style={{ textAlign: 'left-', flex: 1 }}>
                                                        Male [{genderVal !== undefined && genderVal.toLowerCase() === 'male' ? (
                                                            <i className="nav-icon bi bi-check">&nbsp;</i>
                                                            ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                    <span style={{ textAlign: 'center-', flex: 1 }}>
                                                        Female [{genderVal !== undefined && genderVal.toLowerCase() === 'female' ? (
                                                            <i className="nav-icon bi bi-check">&nbsp;</i>
                                                            ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                    <span style={{ textAlign: 'right-', flex: 1 }}>
                                                        Third Gender [{genderVal !== undefined && genderVal.toLowerCase() === 'third gender' ? (
                                                            <i className="nav-icon bi bi-check">&nbsp;</i>
                                                            ) : (<>&nbsp;&nbsp;</>)}]</span>
                                                </div>
                                            );
                                            })()}
                                        </td>
                                    ))} 
                            </tr> 

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Date of Birth</td>
                                <td style={{ borderWidth: '1px' }}>
                                   {(() => {  
                                         return (
                                         <>
                                         {(leadDetails?.dob !=='0000-00-00') ? formatDateForValue(leadDetails?.dob) : ""}
                                         </> 
                                        );
                                        })()}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => {  
                                         return (
                                         <>
                                         {(row?.dob !=='0000-00-00') ? formatDateForValue(row?.dob) : ""}
                                         </> 
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {  
                                         return (
                                         <>
                                          {(row?.dob !=='0000-00-00') ? formatDateForValue(row?.dob) : ""}
                                         </> 
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Father's Name</td>
                                <td style={{ borderWidth: '1px' }}> 
                                   {(() => {
                                        const nameParts = (camDetails?.cam_father_name !== undefined) ? camDetails?.cam_father_name.trim().split(/\s+/) : '';
                                        let firstName = ""; 
                                        let middleName = ""; 
                                        let lastName = "";

                                        if (nameParts.length === 2) {
                                            [firstName, lastName] = nameParts;
                                        } else if (nameParts.length === 3) {
                                            [firstName, middleName, lastName] = nameParts;
                                        } else if (nameParts.length > 3) {
                                            firstName = nameParts[0];
                                            middleName = nameParts[1];
                                            lastName = nameParts.slice(2).join(" ");
                                        } else if (nameParts.length === 1) {
                                            firstName = nameParts[0];
                                        }
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{firstName}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{middleName}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{lastName}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 

                                        const rowInfoArr = coapplicantGuarantorRows.filter(item => item.id === `C${row.id}`);
                                        
                                        // console.log("rowInfoArr = ", rowInfoArr);
                                       // alert('hello');
                                        const nameParts = (rowInfoArr[0]?.father_name !== undefined) ? rowInfoArr[0]?.father_name.trim().split(/\s+/) : ''; 

                                        let firstName = ""; 
                                        let middleName = ""; 
                                        let lastName = rowInfoArr?.father_name;

                                        if (nameParts.length === 2) {
                                            [firstName, lastName] = nameParts;
                                        } else if (nameParts.length === 3) {
                                            [firstName, middleName, lastName] = nameParts;
                                        } else if (nameParts.length > 3) {
                                            firstName = nameParts[0];
                                            middleName = nameParts[1];
                                            lastName = nameParts.slice(2).join(" ");
                                        } else if (nameParts.length === 1) {
                                            firstName = nameParts[0];
                                        }
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{firstName}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{middleName}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{lastName}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           {(() => { 

                                            const rowInfoArr = coapplicantGuarantorRows.filter(item => item.id === `G${row.id}`);

                                            // console.log("rowInfoArr = ", rowInfoArr);
                                            // alert('hello');
                                            const nameParts = (rowInfoArr[0]?.father_name !== undefined) ? rowInfoArr[0]?.father_name.trim().split(/\s+/) : ''; 

                                            let firstName = ""; 
                                            let middleName = ""; 
                                            let lastName = rowInfoArr?.father_name;

                                            if (nameParts.length === 2) {
                                                [firstName, lastName] = nameParts;
                                            } else if (nameParts.length === 3) {
                                                [firstName, middleName, lastName] = nameParts;
                                            } else if (nameParts.length > 3) {
                                                firstName = nameParts[0];
                                                middleName = nameParts[1];
                                                lastName = nameParts.slice(2).join(" ");
                                            } else if (nameParts.length === 1) {
                                                firstName = nameParts[0];
                                            }
                                            return ( 
                                                <div style={{ 
                                                    display: 'flex', 
                                                    justifyContent: 'space-between', 
                                                    alignItems: 'flex-end',  
                                                    height: '100%',
                                                    width:'100%'  
                                                }}>
                                                    <span style={{ textAlign: 'left-', flex: 1 }}>
                                                        <b>{firstName}</b><br/>
                                                        First Name</span>
                                                    <span style={{ textAlign: 'center-', flex: 1 }}>
                                                        <b>{middleName}</b><br/>
                                                        Middle Name</span>
                                                    <span style={{ textAlign: 'right-', flex: 1 }}>
                                                        <b>{lastName}</b><br/>
                                                        Last Name</span>
                                                </div>
                                            );
                                            })()}
                                        </td>
                                    ))} 
                            </tr>


                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Mother's Name</td>
                                <td style={{ borderWidth: '1px' }}> 
                                   {(() => {
                                       
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b> {(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant' && item.field === 'firstName');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(leadDetails?.id, "applicant", e.target.value,'firstName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant' && item.field === 'middleName');  
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <>  
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(leadDetails?.id, "applicant", e.target.value,'middleName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant' && item.field === 'lastName');  
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(leadDetails?.id, "applicant", e.target.value,'lastName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
 
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'firstName');
                                                            
                                                            // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(row?.id, "coApplicant", e.target.value,'firstName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'middleName');
                                                            
                                                            // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(row?.id, "coApplicant", e.target.value,'middleName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'lastName');
                                                            
                                                            // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(row?.id, "coApplicant", e.target.value,'lastName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
 
                                        return ( 
                                            <div style={{ 
                                                display: 'flex', 
                                                justifyContent: 'space-between', 
                                                alignItems: 'flex-end',  
                                                height: '100%',
                                                width:'100%'  
                                            }}>
                                                <span style={{ textAlign: 'left-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'firstName');
                                                            
                                                            // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(row?.id, "guarantor", e.target.value,'firstName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    First Name</span>
                                                <span style={{ textAlign: 'center-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'middleName');
                                                            
                                                            // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(row?.id, "guarantor", e.target.value,'middleName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    Middle Name</span>
                                                <span style={{ textAlign: 'right-', flex: 1 }}>
                                                    <b>{(() => {  
                                                            const selectedArr = motherNameRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'lastName');
                                                            
                                                            // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr[0]?.value}
                                                                    onChange={(e) => handleInputsetMotherNameChange(row?.id, "guarantor", e.target.value,'lastName')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}</b><br/>
                                                    Last Name</span>
                                            </div>
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr>


                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Religion</td>
                                <td style={{ borderWidth: '1px' }}> 
                               
                                {(() => {  
                                 const selectedArr = religionsRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant');  
                                 return (
                                 ( enableUpdatePdfDetails) ? (
                                    <>
                                    
                                        <select 
                                        className="form-select"
                                        value={selectedArr[0]?.value}
                                        onChange={(e) => handleInputChange(leadDetails?.id, "applicant", e.target.value)}
                                        >
                                        <option value='' >Please Select </option>
                                        {
                                            allReligions.length > 0 && allReligions.map((option) => (
                                            <option value={option.name} >
                                                {option.name}
                                            </option>
                                            ))
                                        }
                                        </select>
                                        
                                    </>
                                ) : (
                                    <>
                                     {selectedArr[0]?.value}
                                    </>
                                )
                                );
                            })()}
                                </td>
                                 
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
                                          const selectedArr = religionsRows.filter(item => item.id === row?.id && item.type === 'coApplicant');    
                                        return (    

                                           ( enableUpdatePdfDetails) ? (
                                            <> 
                                             
                                                <select 
                                                className="form-select"
                                                value={selectedArr[0]?.value}
                                                onChange={(e) => handleInputChange(row?.id, "coApplicant", e.target.value)}
                                                >
                                                <option value='' >Please Select </option>
                                                {
                                                    allReligions.length > 0 && allReligions.map((option) => (
                                                    <option value={option.name} >
                                                        {option.name}
                                                    </option>
                                                    ))
                                                }
                                                </select>
                                                 
                                            </>
                                        ) : (
                                            <>
                                            {selectedArr[0]?.value} 
                                            </>
                                        )
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           {(() => { 
                                                const selectedArr = religionsRows.filter(item => item.id === row?.id && item.type === 'guarantor');   
                                                return (
                                            ( enableUpdatePdfDetails) ? (
                                            <>
                                                
                                                <select 
                                                className="form-select"
                                                value={selectedArr[0]?.value}
                                                onChange={(e) => handleInputChange(row?.id, "guarantor", e.target.value)}
                                                >
                                                <option value='' >Please Select </option>
                                                {
                                                    allReligions.length > 0 && allReligions.map((option) => (
                                                    <option value={option.name} >
                                                        {option.name}
                                                    </option>
                                                    ))
                                                }
                                                </select>
                                                
                                            </>
                                        ) : (
                                            <>
                                            {selectedArr[0]?.value}
                                            </>
                                        )
                                         );
                                                })()}
                                        </td>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Category</td>
                                <td style={{ borderWidth: '1px' }}> 
                               
                                {(() => {  
                                 const selectedArr = categoryRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant');  
                                 return (
                                 ( enableUpdatePdfDetails) ? (
                                    <>
                                    
                                        <select 
                                        className="form-select"
                                        value={selectedArr[0]?.value}
                                        onChange={(e) => handleInputsetCategoryChange(leadDetails?.id, "applicant", e.target.value)}
                                        >
                                        <option value='' >Please Select </option>
                                        {
                                            allSocialCategory.length > 0 && allSocialCategory.map((option) => (
                                            <option value={option.name} >
                                                {option.name}
                                            </option>
                                            ))
                                        }
                                        </select>
                                        
                                    </>
                                ) : (
                                    <>
                                     {selectedArr[0]?.value}
                                    </>
                                )
                                );
                            })()}
                                </td>
                                 
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
                                          const selectedArr = categoryRows.filter(item => item.id === row?.id && item.type === 'coApplicant');    
                                        return (    

                                           ( enableUpdatePdfDetails) ? (
                                            <> 
                                             
                                                <select 
                                                className="form-select"
                                                value={selectedArr[0]?.value}
                                                onChange={(e) => handleInputsetCategoryChange(row?.id, "coApplicant", e.target.value)}
                                                >
                                                <option value='' >Please Select </option>
                                                {
                                                    allSocialCategory.length > 0 && allSocialCategory.map((option) => (
                                                    <option value={option.name} >
                                                        {option.name}
                                                    </option>
                                                    ))
                                                }
                                                </select>
                                                 
                                            </>
                                        ) : (
                                            <>
                                            {selectedArr[0]?.value} 
                                            </>
                                        )
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           {(() => { 
                                                const selectedArr = categoryRows.filter(item => item.id === row?.id && item.type === 'guarantor');   
                                                return (
                                            ( enableUpdatePdfDetails) ? (
                                            <>
                                                
                                                <select 
                                                className="form-select"
                                                value={selectedArr[0]?.value}
                                                onChange={(e) => handleInputsetCategoryChange(row?.id, "guarantor", e.target.value)}
                                                >
                                                <option value='' >Please Select </option>
                                                {
                                                    allSocialCategory.length > 0 && allSocialCategory.map((option) => (
                                                    <option value={option.name} >
                                                        {option.name}
                                                    </option>
                                                    ))
                                                }
                                                </select>
                                                
                                            </>
                                        ) : (
                                            <>
                                            {selectedArr[0]?.value}
                                            </>
                                        )
                                         );
                                                })()}
                                        </td>
                                    ))} 
                            </tr>



                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Preferred Language <br/>for Communication</td>
                                <td style={{ borderWidth: '1px' }}> 
                               
                                {(() => {  
                                 const selectedArr = preferredLanguageRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant');  
                                 return (
                                 ( enableUpdatePdfDetails) ? (
                                    <>
                                    
                                        <select 
                                        className="form-select"
                                        value={selectedArr[0]?.value}
                                        onChange={(e) => handleInputsetPreferredLanguageChange(leadDetails?.id, "applicant", e.target.value)}
                                        >
                                        <option value='' >Please Select </option>
                                        {
                                            allPreferredLanguage.length > 0 && allPreferredLanguage.map((option) => (
                                            <option value={option.name} >
                                                {option.name}
                                            </option>
                                            ))
                                        }
                                        </select>
                                        
                                    </>
                                ) : (
                                    <>
                                     {selectedArr[0]?.value}
                                    </>
                                )
                                );
                            })()}
                                </td>
                                 
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
                                          const selectedArr = preferredLanguageRows.filter(item => item.id === row?.id && item.type === 'coApplicant');    
                                        return (    

                                           ( enableUpdatePdfDetails) ? (
                                            <> 
                                             
                                                <select 
                                                className="form-select"
                                                value={selectedArr[0]?.value}
                                                onChange={(e) => handleInputsetPreferredLanguageChange(row?.id, "coApplicant", e.target.value)}
                                                >
                                                <option value='' >Please Select </option>
                                                {
                                                    allPreferredLanguage.length > 0 && allPreferredLanguage.map((option) => (
                                                    <option value={option.name} >
                                                        {option.name}
                                                    </option>
                                                    ))
                                                }
                                                </select>
                                                 
                                            </>
                                        ) : (
                                            <>
                                            {selectedArr[0]?.value} 
                                            </>
                                        )
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           {(() => { 
                                                const selectedArr = preferredLanguageRows.filter(item => item.id === row?.id && item.type === 'guarantor');   
                                                return (
                                            ( enableUpdatePdfDetails) ? (
                                            <>
                                                
                                                <select 
                                                className="form-select"
                                                value={selectedArr[0]?.value}
                                                onChange={(e) => handleInputsetPreferredLanguageChange(row?.id, "guarantor", e.target.value)}
                                                >
                                                <option value='' >Please Select </option>
                                                {
                                                    allPreferredLanguage.length > 0 && allPreferredLanguage.map((option) => (
                                                    <option value={option.name} >
                                                        {option.name}
                                                    </option>
                                                    ))
                                                }
                                                </select>
                                                
                                            </>
                                        ) : (
                                            <>
                                            {selectedArr[0]?.value}
                                            </>
                                        )
                                         );
                                                })()}
                                        </td>
                                    ))} 
                            </tr>


                            <tr> 
                                <td style={{ borderWidth: '1px' }}>
                                    Communication Address<br/> 
                                    (in city of operation <br/> of vehicle)
                                    </td>
                                <td style={{ borderWidth: '1px'}} className="no-padding"> 
                                   {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.lead_id === leadDetails?.id && item.section_name === 'Lead' && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let landMark = '';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const landMarkRow = decodedData.find(row => row.questionText === 'Landmark');
                                              console.log("landMarkRow = ", landMarkRow);
                                          
                                              landMark = landMarkRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                                <tr >
                                                    <td className="no-padding border-bottom">
                                                       &nbsp;Address : {leadDetails?.full_address}
                                                        
                                                        <br/> <br/>
                                                        &nbsp;Land Mark : {landMark} 
                                                         
                                                    </td>
                                                </tr>
                                                

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;City / Town  : {leadDetails?.city}
                                                         
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;District  : {leadDetails?.district}
                                                         
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;State : {leadDetails?.state}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Pin Code : {leadDetails?.pin}
                                                        
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Mobile No.: {leadDetails?.mobile}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Alternate Mobile No.: {(() => {  
                                                            const selectedArr = alternateMobileRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant' && item.field === 'alternateMobile');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetAlternateMobileChange(leadDetails?.id, "applicant", e.target.value,'alternateMobile')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Tel. No.(R) :
                                                          
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;E - mail ID : {leadDetails?.email}  
                                                        
                                                    </td>
                                                </tr>  
                                            </table>
                                            </>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                         {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Co-applicant" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let landMark = '';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const landMarkRow = decodedData.find(rowI => rowI.questionText === 'Landmark');
                                             // console.log("landMarkRow = ", landMarkRow);
                                          
                                              landMark = landMarkRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                                <tr >
                                                    <td className="no-padding border-bottom">
                                                       &nbsp;Address : {row?.full_address}
                                                        
                                                        <br/> <br/>
                                                        &nbsp;Land Mark : {landMark} 
                                                         
                                                    </td>
                                                </tr>
                                                

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;City / Town  : {row?.city}
                                                         
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;District  : {row?.district}
                                                         
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;State : {row?.state}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Pin Code : {row?.pin}
                                                        
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Mobile No.: {row?.mobile}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Alternate Mobile No.: {(() => {  
                                                            const selectedArr = alternateMobileRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'alternateMobile');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetAlternateMobileChange(row?.id, "coApplicant", e.target.value,'alternateMobile')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Tel. No.(R) :
                                                          
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;E - mail ID : {row?.email}  
                                                        
                                                    </td>
                                                </tr>  
                                            </table>
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Guarantor" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let landMark = '';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const landMarkRow = decodedData.find(rowI => rowI.questionText === 'Landmark');
                                             // console.log("landMarkRow = ", landMarkRow);
                                          
                                              landMark = landMarkRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                                <tr >
                                                    <td className="no-padding border-bottom">
                                                       &nbsp;Address : {row?.full_address}
                                                        
                                                        <br/> <br/>
                                                        &nbsp;Land Mark : {landMark} 
                                                         
                                                    </td>
                                                </tr>
                                                

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;City / Town  : {row?.city}
                                                         
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;District  : {row?.district}
                                                         
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;State : {row?.state}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Pin Code : {row?.pin}
                                                        
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Mobile No.: {row?.mobile}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Alternate Mobile No.: {(() => {  
                                                            const selectedArr = alternateMobileRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'alternateMobile');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetAlternateMobileChange(row?.id, "guarantor", e.target.value,'alternateMobile')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Tel. No.(R) :
                                                          
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;E - mail ID : {row?.email}  
                                                        
                                                    </td>
                                                </tr>  
                                            </table>
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>
                                    Residence type </td>
                                <td style={{ borderWidth: '1px'}} className="no-padding"> 
                                   {(() => {
                                    // 27 -  
                                        console.log("leadDetails = ",leadDetails);
                                         const checkListArr = allLeadCheckLists.filter(item => item.lead_id === leadDetails?.id && item.section_name === 'Lead' && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let residenceStatus = '';  
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const residenceStatusRow = decodedData.find(rowI => rowI.questionText === "Residence status");
                                               
                                              residenceStatus = residenceStatusRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                                {residenceStatus}
                                            </>
                                        );
                                        })()}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                         {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Co-applicant" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let residenceStatus = '';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const residenceStatusRow = decodedData.find(rowI => rowI.questionText === 'Residence status');
                                             // console.log("landMarkRow = ", landMarkRow);
                                          
                                             residenceStatus = residenceStatusRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                             {residenceStatus}
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Guarantor" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let residenceStatus = '';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const residenceStatusRow = decodedData.find(rowI => rowI.questionText === 'Residence status');
                                             // console.log("landMarkRow = ", landMarkRow);
                                          
                                             residenceStatus = residenceStatusRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            {residenceStatus}
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr>


                            <tr> 
                                <td style={{ borderWidth: '1px' }}>
                                Number of years of stay<br/> 
                                (in city of operation <br/>of vehicle)
                                </td>
                                <td style={{ borderWidth: '1px'}} className="no-padding"> 
                                   {(() => {
                                    // 27 -  
                                        console.log("leadDetails = ",leadDetails);
                                         const checkListArr = allLeadCheckLists.filter(item => item.lead_id === leadDetails?.id && item.section_name === 'Lead' && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let residenceStatus = '';  
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const residenceStatusRow = decodedData.find(rowI => rowI.questionText === "Living Since");
                                               
                                              residenceStatus = residenceStatusRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                                {residenceStatus}
                                            </>
                                        );
                                        })()}
                                </td> 
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                         {(() => {
                                    // 27 -  
                                          const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Co-applicant" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let residenceStatus = '';  

                                          if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const residenceStatusRow = decodedData.find(rowI => rowI.questionText === 'Living Since');
                                           
                                             residenceStatus = residenceStatusRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                             {residenceStatus}
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {
                                    // 27 -  
                                          const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Guarantor" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let residenceStatus = '';  

                                         if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const residenceStatusRow = decodedData.find(rowI => rowI.questionText === 'Living Since');
                                           
                                             residenceStatus = residenceStatusRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            {residenceStatus}
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr>



                            <tr> 
                                <td style={{ borderWidth: '1px' }}>
                                    Permanent Address
                                    </td>
                                <td style={{ borderWidth: '1px'}} className="no-padding"> 
                                   {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.lead_id === leadDetails?.id && item.section_name === 'Lead' && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let landMark = '';  

                                          console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const landMarkRow = decodedData.find(row => row.questionText === 'Landmark');
                                              console.log("landMarkRow = ", landMarkRow);
                                          
                                              landMark = landMarkRow?.userAnswers?.[0] || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                                <tr >
                                                    <td className="no-padding border-bottom">
                                                       &nbsp;Address : {camDetails?.cam_address}
                                                        
                                                        <br/> <br/>
                                                        &nbsp;Land Mark : {camDetails?.cam_permanent_landmark} 
                                                         
                                                    </td>
                                                </tr>
                                                

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;City / Town  : {camDetails?.cam_permanent_city}
                                                         
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;District  : {camDetails?.cam_permanent_district}
                                                         
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;State : {camDetails?.cam_permanent_state}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Pin Code : {camDetails?.cam_permanent_pin}
                                                        
                                                    </td>
                                                </tr> 
                                                 
                                            </table>
                                            </>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                         {(() => {
                                    
                                        return ( 
                                             <>
                                            <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                                <tr >
                                                    <td className="no-padding border-bottom">
                                                       &nbsp;Address : {(() => {  
                                                            const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'address');;
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "coApplicant", e.target.value,'address')}
                                                                     /> 
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                        
                                                        <br/> <br/>
                                                        &nbsp;Land Mark : {(() => {  
                                                            const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'landmark');;
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "coApplicant", e.target.value,'landmark')}
                                                                     /> 
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}
                                                         
                                                    </td>
                                                </tr>
                                                

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;City / Town  : {(() => {  
                                                            const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'cityTown');;
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "coApplicant", e.target.value,'cityTown')}
                                                                     /> 
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}
                                                         
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;District  : {(() => {  
                                                            const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'district');;
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "coApplicant", e.target.value,'district')}
                                                                     /> 
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}
                                                         
                                                    </td>
                                                </tr> 

                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;State : {(() => {  
                                                            const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'state');;
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "coApplicant", e.target.value,'state')}
                                                                     /> 
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}
                                                         
                                                    </td>
                                                </tr> 
                                                <tr>
                                                    <td className="no-padding border-bottom">
                                                    &nbsp;Pin Code : {(() => {  
                                                            const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'pin');;
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "coApplicant", e.target.value,'pin')}
                                                                     /> 
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()}
                                                        
                                                    </td>
                                                </tr> 
                                                 
                                            </table>
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {
                                    
                                    return ( 
                                         <>
                                        <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                   &nbsp;Address : {(() => {  
                                                        const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'address');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "guarantor", e.target.value,'address')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()} 
                                                    
                                                    <br/> <br/>
                                                    &nbsp;Land Mark : {(() => {  
                                                        const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'landmark');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "guarantor", e.target.value,'landmark')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                                     
                                                </td>
                                            </tr>
                                            

                                            <tr>
                                                <td className="no-padding border-bottom">
                                                &nbsp;City / Town  : {(() => {  
                                                        const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'cityTown');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "guarantor", e.target.value,'cityTown')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                                     
                                                </td>
                                            </tr>

                                            <tr>
                                                <td className="no-padding border-bottom">
                                                &nbsp;District  : {(() => {  
                                                        const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'district');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "guarantor", e.target.value,'district')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                                     
                                                </td>
                                            </tr> 

                                            <tr>
                                                <td className="no-padding border-bottom">
                                                &nbsp;State : {(() => {  
                                                        const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'state');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "guarantor", e.target.value,'state')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                                     
                                                </td>
                                            </tr> 
                                            <tr>
                                                <td className="no-padding border-bottom">
                                                &nbsp;Pin Code : {(() => {  
                                                        const selectedArr = parmanentAddressRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'pin');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetParmanentAddressChange(row?.id, "guarantor", e.target.value,'pin')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                                    
                                                </td>
                                            </tr> 
                                             
                                        </table>
                                        </>
                                    );
                                    })()}
                                        </td>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>
                                Marital Status   </td>
                                <td style={{ borderWidth: '1px'}} className="no-padding"> 
                                   {(() => {
                                    // 27 -  
                                        console.log("leadDetails = ",leadDetails);
                                         const checkListArr = allLeadCheckLists.filter(item => item.lead_id === leadDetails?.id && item.section_name === 'Lead' && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let fiValue = 'Single';  
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const fiValueRow = decodedData.find(rowI => rowI.questionText === "Marital Status");
                                               
                                              fiValue = (fiValueRow?.userAnswers?.[0] === 'Married' ? "Married" : "Single" ) || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                                {fiValue}<br/>
                                                No. of Dependents : {(() => {  
                                                        const selectedArr = noOfDependentsRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant' && item.field === 'no_of_dependents');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetNoOfDependentsChange(leadDetails?.id, "applicant", e.target.value,'no_of_dependents')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                            </>
                                        );
                                        })()}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                         {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Co-applicant" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let fiValue = 'Single';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const fiValueRow = decodedData.find(rowI => rowI.questionText === 'Marital Status');
                                             // console.log("landMarkRow = ", landMarkRow);
                                          
                                             fiValue = (fiValueRow?.userAnswers?.[0] === 'Married' ? "Married" : "Single" ) || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                             {fiValue}<br/>
                                             No. of Dependents : {(() => {  
                                                        const selectedArr = noOfDependentsRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'no_of_dependents');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetNoOfDependentsChange(row?.id, "coApplicant", e.target.value,'no_of_dependents')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {
                                    // 27 -  
                                       // console.log("allLeadCheckLists = ",allLeadCheckLists);
                                         const checkListArr = allLeadCheckLists.filter(item => item.section_id === row?.id && item.section_name === "Guarantor" && Number(item.checklist_id) > 17 && Number(item.checklist_id) < 27);
                                         let fiValue = 'Single';  

                                        //  console.log("checkListArr = ",checkListArr);
                                        //  console.log("leadDetails = ",leadDetails);
                                        if (Array.isArray(checkListArr) && checkListArr.length > 0) {
                                            const decodedData = checkListArr[0]?.questions_data_decoded;
                                          
                                            if (Array.isArray(decodedData) && decodedData.length > 0) {
                                              const fiValueRow = decodedData.find(rowI => rowI.questionText === 'Marital Status');
                                             // console.log("landMarkRow = ", landMarkRow);
                                          
                                             fiValue = (fiValueRow?.userAnswers?.[0] === 'Married' ? "Married" : "Single" ) || '';
                                            }
                                          }

                                        return ( 
                                             <>
                                            {fiValue}<br/>
                                            No. of Dependents : {(() => {  
                                                        const selectedArr = noOfDependentsRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'no_of_dependents');;
                                                        return (
                                                        ( enableUpdatePdfDetails) ? (
                                                            <> 
                                                                <input 
                                                                className="form-control"
                                                                value={selectedArr?.[0]?.value}
                                                                onChange={(e) => handleInputsetNoOfDependentsChange(row?.id, "guarantor", e.target.value,'no_of_dependents')}
                                                                 /> 
                                                            </>
                                                        ) : (
                                                            <>
                                                            {selectedArr?.[0]?.value}
                                                            </>
                                                        )
                                                        );
                                                    })()}
                                            </>
                                        );
                                        })()}
                                        </td>
                                    ))} 
                            </tr> 
  

    <tr>  
                                <td style={{ borderWidth: '1px' }}>
                                   Education
                                    </td>
                                <td style={{ borderWidth: '1px'}} className="no-padding"> 
                                   {(() => {
                                        return ( 
                                             <>
                                            
                                                    {(() => {  
                                                            const selectedArr = educationDetailsRows.filter(item => item.id === leadDetails?.id && item.type === 'applicant' && item.field === 'educationDetails');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetEducationDetailsChange(leadDetails?.id, "applicant", e.target.value,'educationDetails')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                     
                                            </>
                                        );
                                        })()}

                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                         {(() => {
                                    
                                        return ( 
                                             <>
                                            
                                                    {(() => {  
                                                            const selectedArr = educationDetailsRows.filter(item => item.id === row?.id && item.type === 'coApplicant' && item.field === 'educationDetails');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetEducationDetailsChange(row?.id, "coApplicant", e.target.value,'educationDetails')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                    
                                            </>
                                        );
                                        })()}&nbsp;
                                        </td>
                                    ))} 

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                          {(() => {
                                     

                                        return ( 
                                             <>
                                           
                                                    {(() => {  
                                                            const selectedArr = educationDetailsRows.filter(item => item.id === row?.id && item.type === 'guarantor' && item.field === 'educationDetails');
                                                            
                                                           // console.log("selectedArr = ", selectedArr);
                                                            return (
                                                            ( enableUpdatePdfDetails) ? (
                                                                <> 
                                                                    <input 
                                                                    className="form-control"
                                                                    value={selectedArr?.[0]?.value}
                                                                    onChange={(e) => handleInputsetEducationDetailsChange(row?.id, "guarantor", e.target.value,'educationDetails')}
                                                                     /> 
                                                                    
                                                                </>
                                                            ) : (
                                                                <>
                                                                {selectedArr?.[0]?.value}
                                                                </>
                                                            )
                                                            );
                                                        })()} 
                                                         
                                                   
                                            </>
                                        );
                                        })()} &nbsp;
                                        </td>
                                    ))} 
                            </tr>


                            <tr> 
                                <td colSpan ={verticalTotalColspan} style={{ borderWidth: '1px', textAlign: 'center' }}>
                                 <b>KYC-DOCUMENT SUBMITTED FOR ID & ADDRESS PROOF</b></td> 
                            </tr>

                             <tr> 
                                <td colSpan ={verticalTotalColspan}  style={{ borderWidth: '1px' }}>
                                    
                                     <table style={{ border: '0px',width:'100%' }}>
                                        <tr> 
                                            <td style={{ borderWidth: '1px-', valign :'top', paddingLeft: '0px' }} className="no-padding-left">Applicant : </td> 
                                            <td style={{ borderWidth: '1px-' }}>
                                                    PAN -
                                                    {leadDetails?.pancard_number ? leadDetails.pancard_number.replace(/["\\]/g, '') : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>
                                                Aadhar -
                                                 {leadDetails?.adhar_number ? leadDetails.adhar_number.replace(/["\\]/g, '') : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>
                                                    Driving License -
                                                    {( leadDetails.id === camDetails?.cam_who_is_driver || camDetails?.cam_who_is_driver === '') ? camDetails?.cam_dl : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>Passsport - </td> 
                                            <td style={{ borderWidth: '1px-' }}>Voter ID  - </td>
                                            <td style={{ borderWidth: '1px-' }}>Gas Connection  - </td>
                                            <td style={{ borderWidth: '1px-' }}>E-bill  - </td>
                                        </tr>

                                        {addedAllCoApplicants.map((row, index) => (
                                        <tr> 
                                            <td style={{ borderWidth: '1px-', valign :'top',paddingLeft: '0px' }} className="no-padding-left">Co Applicant : </td> 
                                            <td style={{ borderWidth: '1px-' }}>
                                                    PAN - {row?.pan_number ? row.pan_number.replace(/["\\]/g, '') : ''} 
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>
                                                Aadhar - {row?.adhar_number ? row.adhar_number.replace(/["\\]/g, '') : ''} 
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>
                                                    Driving License - {( `C${row.id}` === camDetails?.cam_who_is_driver ) ? camDetails?.cam_dl : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>Passsport - </td> 
                                            <td style={{ borderWidth: '1px-' }}>Voter ID  - </td>
                                            <td style={{ borderWidth: '1px-' }}>Gas Connection  - </td>
                                            <td style={{ borderWidth: '1px-' }}>E-bill  - </td>
                                        </tr>
                                        ))}

                                        {addedAllGuarantors.map((row, index) => (
                                        <tr> 
                                            <td style={{ borderWidth: '1px-', valign :'top', paddingLeft: '0px' }} className="no-padding-left">Guarantor : </td> 
                                            <td style={{ borderWidth: '1px-' }}>
                                                    PAN - {row?.pan_number ? row.pan_number.replace(/["\\]/g, '') : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>
                                                Aadhar - {row?.aadhaar_number ? row.aadhaar_number.replace(/["\\]/g, '') : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>
                                                    Driving License - {( `G${row.id}` === camDetails?.cam_who_is_driver ) ? camDetails?.cam_dl : ''}
                                            </td>
                                            <td style={{ borderWidth: '1px-' }}>Passsport - </td> 
                                            <td style={{ borderWidth: '1px-' }}>Voter ID  - </td>
                                            <td style={{ borderWidth: '1px-' }}>Gas Connection  - </td>
                                            <td style={{ borderWidth: '1px-' }}>E-bill  - </td>
                                        </tr>
                                        ))}
                                        
                                       
                                    </table>

                                </td>
                            </tr>

                            <tr> 
                                <td colSpan ={verticalTotalColspan} style={{ borderWidth: '1px', textAlign: 'center' }}>* Any one for Id Proof & One for Address Proof (Not required in case of e-KYC)</td> 
                            </tr> 
  
                         { /*   <tr> 
                                <td style={{ borderWidth: '1px' }}>MSME Certificate No</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;
                                
                                {(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Certificate Copy" && item.section_name === "MSME Certificate"); 
                                    return ( 
                                        <>
                                        {selectedArr[0]?.registration_no}
                                        </> 
                                    );
                                })()}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                ))}

                                {addedAllGuarantors.map((row, index) => (
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>CIN No (In case of Company)</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                ))}

                                {addedAllGuarantors.map((row, index) => (
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                ))} 
                            </tr>

                             */ }

                           
                        </table>
                        </> 



                    <div style={{ clear: 'both' }}>&nbsp;</div>
                        <table style={{ border: '1px',width:'100%' }}>
                            <tr> 
                                <td colSpan ="4" style={{ borderWidth: '1px', textAlign: 'center' }}>
                                 <b>Asset related & other documents (as applicable)</b></td> 
                            </tr>

                            <tr> 
                                <td colSpan ="4" style={{ borderWidth: '1px', textAlign: 'center' }}>Pre-sanction documents</td> 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>1. Proforma invoice & Margin Money receipt for new asset</td> 
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                                 <td style={{ borderWidth: '1px' }}>4. Comprehensive insurance policy </td> 
                               
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>2. Partner Recommendation letter for Applicant </td> 
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                                 <td style={{ borderWidth: '1px' }}>5. Bank statement of last 6 months</td>
                               
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>3. Partner Contract with Applicant  </td> 
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                                <td style={{ borderWidth: '1px' }}>6. Last 2 years ITR in case of income assessed</td>
                               
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                            </tr>

                            
                         
                            <tr> 
                                <td colSpan ="4" style={{ borderWidth: '1px', textAlign: 'center' }}>
                                 Post-disbursement documents</td> 
                            </tr> 

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>1. Original invoice for new asset with hypothecation in favor of Company</td> 
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                                <td style={{ borderWidth: '1px' }}>3. Insurance policy hypothecation in favor of Company</td>
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                            </tr>
 
                            <tr> 
                                <td style={{ borderWidth: '1px' }}>2. Registration Certificate and hypothecation in favor  of Company </td> 
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                                <td style={{ borderWidth: '1px' }}>4. Others  </td>
                                <td style={{ borderWidth: '1px' }}>[ &nbsp;&nbsp; ]</td>
                            </tr>
                        </table>

                        <div style={{ clear: 'both' }}>&nbsp;</div>
                        <table style={{ border: '1px',width:'100%' }}>
                            <tr> 
                                <td colSpan ="8" style={{ borderWidth: '1px', textAlign: 'center' }}>
                                 <b>Bank Account Details  (Applicant)</b></td> 
                            </tr>

                            <tr> 
                                <th style={{ borderWidth: '1px' }}>Name of the Bank</th> 
                                <th style={{ borderWidth: '1px' }}>Branch</th>
                                <th style={{ borderWidth: '1px' }}>Account Type</th>
                                <th style={{ borderWidth: '1px' }}>Account No.</th>
                                <th style={{ borderWidth: '1px' }}>Account Since</th> 
                                <th style={{ borderWidth: '1px' }}>IFSC Code</th>
                                <th style={{ borderWidth: '1px' }}>Average Debit Per Month</th>
                                <th style={{ borderWidth: '1px' }}>Average Credit Per Month</th>
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>{camDetails?.remarks_bank_name}</td> 
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.remarks_type_of_account}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.remarks_account_no}</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td> 
                                <td style={{ borderWidth: '1px' }}>{camDetails?.remarks_ifsc_code}</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            </tr>
                            <tr> 
                                <td colSpan ="8" style={{ borderWidth: '1px', textAlign: 'center' }}>
                                 &nbsp;</td> 
                            </tr>

                          {/*  <tr> 
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>
                                If employed <br/><br/></td> 
                                 <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                 Company Name :<br/><br/> </td> 
                                 <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                 No.  of years  of employment  :<br/><br/> </td> 
                            </tr> */ }
                        </table>


                        <div style={{ clear: 'both' }}>&nbsp;</div>
                        <table style={{ border: '1px',width:'100%' }}>
                            <tr> 
                                <td colSpan ="5" style={{ borderWidth: '1px', textAlign: 'center' }}>
                                 <b>DETAILS OF Vehicles OWNED BY APPLICANT</b></td> 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Vehicle</td> 
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                     <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                    Registration No
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            1. 
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            2.   
                                            </td>
                                        </tr> 

                                        
                                            
                                    </table>
                                    
                                </td>
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                            Make & Model
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
 

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
                                            
                                    </table>

                                </td>
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                            Applicant Declared Value
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>

                                        

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
                                            
                                    </table>
                                </td>
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                            Financed By / Free
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>

                                       
                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
                                            
                                    </table>
                                </td> 
                                 
                            </tr>

                            <tr> 
                                <td colSpan ="1" style={{ borderWidth: '1px' }}>&nbsp;</td> 
                                 <td colSpan ="4" style={{ borderWidth: '1px' }}>* if more number of vehicles, details may be given separately.</td> 
                            </tr>

                            <tr> 
                                  <td colSpan ="5" style={{ borderWidth: '1px', textAlign: 'center'}}> Details OF Vehicles OWNED BY Guarantor</td> 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td> 
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                     <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                    Registration No
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            1. 
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            2.   
                                            </td>
                                        </tr> 

                                        
                                        <tr>
                                            <td className="no-padding border-bottom">
                                            S. Others. if any (PI. mention) 
                                            </td>
                                        </tr>
                                            
                                    </table>
                                    
                                </td>
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                            Make & Model
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>

                                        
                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr> 

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
                                            
                                    </table>

                                </td>
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                            Applicant Declared Value
                                            </td>
                                        </tr>

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>

                                        
                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr> 

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
                                            
                                    </table>
                                </td>
                                <td style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                            Financed By / Free
                                            </td>
                                        </tr>

                                        

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr> 
                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr> 

                                        <tr>
                                            <td className="no-padding border-bottom">
                                            &nbsp; 
                                            </td>
                                        </tr>
                                            
                                    </table>
                                </td> 
                                 
                            </tr>

                            <tr> 
                                  <td colSpan ="1" style={{ borderWidth: '1px' }}> Other Movable Property</td> 
                                  <td colSpan ="2" style={{ borderWidth: '1px' }}> Investment Bonds, FD’ s etc Specify : </td> 
                                  <td colSpan ="3" style={{ borderWidth: '1px' }}> Total Value in Rs : </td> 
                            </tr>
                             
                        </table>

                        <table style={{ borderWidth: '1px',width:'100%' }} >
                            <tr >
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Segment : EV</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Partner </td>
                            </tr>

                            <tr >
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Make : {leadDetails?.oemName}</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Model : {camDetails?.cam_vehicle_models}</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Year of Manufacture : </td>
                            </tr>

                            <tr >
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Registration Number  </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Engine Number : 
                                {(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Engine Number" && item.section_name === "Vehicle Dedupe"); 
                                    return ( 
                                        <>
                                        {selectedArr[0]?.vehicle_dedupe_no}
                                        </> 
                                    );
                                })()}</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Chassis  number : 
                                {(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Chasis Number" && item.section_name === "Vehicle Dedupe"); 
                                    return ( 
                                        <>
                                        {selectedArr[0]?.vehicle_dedupe_no}
                                        </> 
                                    );
                                })()}
                                </td>
                            </tr>

                            <tr >
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Vehicle (New / Used) : New</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Purchase Price : {camDetails?.dmemo_total_cost_per_vehicle}</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Margin Money : {camDetails?.dmemo_margin_money_all_vehicle}</td>
                            </tr>

                            <tr >
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Battery Number : </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Insurance policy Number : </td>
                            </tr>

                            <tr >
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Charger  Number :</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>National Permit :<br/>
                                State Permit : </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Permitted States :
                                <br/>Permit No & Permit Valid Up to : </td>
                            </tr>

 
                           {/* <tr >
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>&nbsp; <br/><br/></td>
                            </tr> */ }
                            <tr >
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                     MI Policy being Taken?    Yes [ &nbsp;&nbsp; ] / No [ &nbsp;&nbsp; ]
                                    &nbsp; 
                                    <br/><br/>
                                    LI Policy being Taken?    Yes  [ &nbsp;&nbsp; ]  / No [ &nbsp;&nbsp; ]
                                </td>
                                
                            </tr>

                        </table>

                        <table style={{ borderWidth: '1px',width:'100%' }} >
                            <tr >
                                <td colSpan ="10" style={{ borderWidth: '1px',textAlign: 'center' }}>                                    
                                <b>Existing Relationship with {(camDetails?.cam_lender ==='Vivriti') ? (
                                <>Vivriti Capital Limited (VCL)</>) : (<>cKers Finance Private Limited</>)}</b>
                                </td>
                             </tr>

                             <tr >
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Existing Relationship-Applicant</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Customer ID </td>
                                <td colSpan ="5" style={{ borderWidth: '1px' }}>Existing Relationship-Guarantor </td>
                            </tr>

                            <tr >
                                <td style={{ borderWidth: '1px' }}>Loan No.</td>
                                <td style={{ borderWidth: '1px' }}>Date of Disb</td>
                                <td style={{ borderWidth: '1px' }}>Disb Amount</td>
                                <td style={{ borderWidth: '1px' }}>Balance</td>
                                <td style={{ borderWidth: '1px' }}>Total Amount Due </td>
                                <td style={{ borderWidth: '1px' }}>Loan No.</td>
                                <td style={{ borderWidth: '1px' }}>Date of Disb</td>
                                <td style={{ borderWidth: '1px' }}>Disb Amount</td>
                                <td style={{ borderWidth: '1px' }}>Balance</td>
                                <td style={{ borderWidth: '1px' }}>Total Amount Due </td>
                            </tr>
                            <tr >
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            </tr>
                            <tr >
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                            </tr>
                            


                            <tr >
                                <td colSpan ="10" style={{ borderWidth: '1px',textAlign: 'center' }}>  
                                <br/>                                  
                                <b>Existing Loan From Other Banks/NBFCs/Others (Specify) <br/> (Applicant)</b>
                                <br/> 
                                </td>
                             </tr>

                            <tr >
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Type of Facility</td>
                                <td style={{ borderWidth: '1px' }}>Amount Borrowed </td>
                                <td style={{ borderWidth: '1px' }}>Month & Year of Borrowing</td>
                                <td style={{ borderWidth: '1px' }}>EMI</td>
                                <td style={{ borderWidth: '1px' }}>Rate of Interest</td>
                                <td style={{ borderWidth: '1px' }}>Tenure</td>
                                <td style={{ borderWidth: '1px' }}>Outstanding Balancet</td>
                                 <td colSpan ="2"  style={{ borderWidth: '1px' }}>Status </td>
                            </tr>
                            <tr >
                                <td style={{ borderWidth: '1px' }}>Term&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>WCL&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>STD&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>NPA&nbsp;</td>
                            </tr>
                            <tr >
                                <td style={{ borderWidth: '1px' }}>Term&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>WCL&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>STD&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>NPA&nbsp;</td>
                            </tr>
                            

                            <tr >
                                <td colSpan ="10" style={{ borderWidth: '1px'}}>                                    
                                If more number of Loans, details may be furnished separately
                                </td>
                             </tr>

                             <tr >
                                <td colSpan ="10" style={{ borderWidth: '1px',textAlign: 'center' }}>  
                                <br/>                                  
                                <b>Existing Loan From Other Banks/NBFCs/Others (Specify) <br/> (Guarantor)</b>
                                <br/> 
                                </td>
                             </tr>

                            <tr >
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>Type of Facility</td>
                                <td style={{ borderWidth: '1px' }}>Amount Borrowed </td>
                                <td style={{ borderWidth: '1px' }}>Month & Year of Borrowing</td>
                                <td style={{ borderWidth: '1px' }}>EMI</td>
                                <td style={{ borderWidth: '1px' }}>Rate of Interest</td>
                                <td style={{ borderWidth: '1px' }}>Tenure</td>
                                <td style={{ borderWidth: '1px' }}>Outstanding Balancet</td>
                                 <td colSpan ="2"  style={{ borderWidth: '1px' }}>Status </td>
                            </tr>
                            <tr >
                                <td style={{ borderWidth: '1px' }}>Term&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>WCL&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>STD&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>NPA&nbsp;</td>
                            </tr>
                            <tr >
                                <td style={{ borderWidth: '1px' }}>Term&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>WCL&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>STD&nbsp;</td>
                                <td style={{ borderWidth: '1px' }}>NPA&nbsp;</td>
                            </tr>
                            
                        </table>

                        <div style={{ clear: 'both' }}>
                            <br/>
                            <b>Reference details (2)</b>
                            <br/>       
                        </div>
                        <table style={{ border: '1px',width:'100%' }}>
                            <tr>
                                <td style={{ borderWidth: '1px' }}>S.No</td>
                                <td style={{ borderWidth: '1px' }}>Name</td>
                                <td style={{ borderWidth: '1px' }}>Address</td>
                                <td style={{ borderWidth: '1px' }}>Relationship</td>
                                <td style={{ borderWidth: '1px' }}>Phone Number</td>
                            </tr>   

                            <tr>
                                <td style={{ borderWidth: '1px' }}>1</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_name_1}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_address_1}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_relationship_1}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_phone_1}</td>
                            </tr>   

                            <tr>
                                <td style={{ borderWidth: '1px' }}>2</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_name_2}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_address_2}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_relationship_2}</td>
                                <td style={{ borderWidth: '1px' }}>{camDetails?.cam_reference_phone_2}</td>
                            </tr>  
                             
                        </table>                 
                     

                        <div style={{ clear: 'both' }}>
                            &nbsp;    
                        </div>
                      {/*  <table style={{ border: '1px',width:'100%' }}>
                            <tr >
                                <td colSpan ="12" style={{ borderWidth: '1px',textAlign: 'center' }}>  
                                <br/>                                  
                                <b>BUSINESS DETAILS OF THE APPLICANT (as applicable)</b>
                                <br/> 
                                </td>
                            </tr>
                            <tr>
                                <td style={{ borderWidth: '1px',textAlign: 'left' }}>Please enter all financial no’s (INR in lakhs)</td>
                                <td style={{ borderWidth: '1px',textAlign: 'right' }}>All Fields Mandatory</td>
                                 
                            </tr>  

                            <tr >
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>  
                                <br/>                                  
                                <b>DETAILS OF COMPANY / PARTNERSHIP / PROPRIETORSHIP FIRM</b>
                                <br/> 
                                </td>
                            </tr> 
                            <tr >
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>  
                                <br/>                                  
                                <b>None:</b>
                                <br/> 
                                </td>
                            </tr> 

                            <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>
                                    <b>LEGAL STATUS :</b>
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>
                                Proprietorship Concern [ &nbsp; &nbsp; ] <br/>
                                HUF [ &nbsp; &nbsp; ] 
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Unregistered Partnership  [ &nbsp; &nbsp; ] <br/>
                                Public Limited [ &nbsp; &nbsp; ] 
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Registered Partnership [ &nbsp; &nbsp; ] <br/>
                                Private Limited [ &nbsp; &nbsp; ] 
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>
                                Trust [ &nbsp; &nbsp; ] <br/>
                                Society [ &nbsp; &nbsp; ] 
                                </td>
                            </tr> 

                            <tr>
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                     YEAR OF INCORPORATION : 
                                </td>
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                ROC REGN NO/ PARTNERSHIP DEED NO :
                                </td> 
                            </tr> 
                            <tr>
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                PAN NO :
                                </td>
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                GSTIN :
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="4" style={{ borderWidth: '1px' }}>
                                NATURE OF BUSINESS :
                                </td>
                                <td colSpan ="4" style={{ borderWidth: '1px' }}>
                                ANNUAL INCOME :
                                </td> 
                                <td colSpan ="4" style={{ borderWidth: '1px' }}>
                                ANNUAL TURNOVER :
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                REGISTERED OFFICE ADDRESS :
                                <br/> <br/> <br/> <br/> <br/> <br/>
                                </td>                                
                            </tr>

                            <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Landline No 1 :
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Mobile no. :
                                </td> 
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                No of Branches
                                </td> 
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                No of Cities
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Ownership : Owned	/  Rented
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Build up Area (sq ft)
                                </td> 
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                No of Permanent Employees :
                                </td> 
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                No of Temporary Employees :
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                Advance Tax Paid : Yes / No
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                <b>DETAILS OF CONTACT PERSON</b>
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                Name :
                                </td>
                                <td colSpan ="6" style={{ borderWidth: '1px' }}>
                                Designation :
                                </td>
                            </tr>

                            <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                PAN Card No :
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Mobile No :
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Aadhaar No :
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Email Id :
                                </td>
                            </tr>

                            <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                <b>DETAILS OF SHAREHOLDING PATTERN IN PARTNERSHIP FIRM / PRIVATE LIMITED / PUBLIC LIMITED</b>
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Name of Shareholder
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                No of Shares
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                % Holding
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                Relationship with Promoters
                                </td>
                            </tr>

                            <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr> 
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>

                             <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                <b>PARTNERS / DIRECTORS DETAILS (City Manager to verify all the partner details)</b>
                                </td> 
                            </tr>

                            <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Name & Address of Partner / Director</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Relationship with Promoters</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Date of Birth</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Educational Background</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>
                                  
&nbsp;
                                </td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Experience in Industry</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>PAN No.</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Annual Income</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Telephone / Mobile No.</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>
                             <tr>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>Email id</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="3" style={{ borderWidth: '1px' }}>&nbsp;</td>
                             </tr>

                             <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px',textAlign: 'center' }}>
                                 <br/>   
                                <b>OPERATING ECONOMICS</b>
                                <br/> 
                                </td> 
                            </tr>

                            </table>     
                            
                        <div style={{ clear: 'both' }}>
                            &nbsp;    
                        </div> */}
                        <table style={{ border: '1px',width:'100%' }}>    

                         { /*   <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>&nbsp;</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }}>Number of Vehicles</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>&nbsp;</td> 
                             </tr>

                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>A</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }}>Earning Per month</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>&nbsp;</td> 
                             </tr>

                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>&nbsp;</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }} className="no-padding">
                                    <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;Approx. Monthly Expenses towards Vehicle operation:
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;1. Tax + Permit -insurance * Other RTO Expenses
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;2. Driver & Helper Salary
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;3. Charging Expenses
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;4. Tyre + Maintenance + Miscellaneous Expenses
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom" style={{ textAlign: 'right'  }}>
                                                    &nbsp;(B) Total: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </td>
                                            </tr>
                                    </table>           
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }} className="no-padding">
                                <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                &nbsp;
                                            </td>
                                        </tr>
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                &nbsp;
                                            </td>
                                        </tr>
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                &nbsp;
                                            </td>
                                        </tr>
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                &nbsp;
                                            </td>
                                        </tr>
                                        <tr >
                                            <td className="no-padding border-bottom">
                                                &nbsp;
                                            </td>
                                        </tr>
                                        <tr >
                                            <td className="no-padding border-bottom" >
                                                &nbsp;
                                            </td>
                                        </tr>
                                </table>
                                </td> 
                             </tr>

                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>C</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }}>Net Earning Per Month (A - B)</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>&nbsp;</td> 
                             </tr>


                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>D</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }}>Approx. Installment Payable Per Month</td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }}>&nbsp;</td> 
                             </tr>

                             <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px',textAlign: 'center'  }}>Calculations (As Applicable)</td> 
                             </tr>

                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>&nbsp;</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }} className="no-padding">
                                    <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;a. Number of Trips Per Days
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;b. Number of days
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    &nbsp;c. Rate per Trip 
                                                </td>
                                            </tr>
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    
                                                    <table style={{ borderWidth: '0px',width:'100%' }} className="no-padding">
                                                        <tr >
                                                            <td className="no-padding- border-bottom" style={{ borderWidth: '1px'}}>
                                                            Total Rate per month
                                                            </td>
                                                            <td className="no-padding- border-bottom" style={{ borderWidth: '1px'}}>
                                                            (A)
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            
                                    </table>           
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }} className="no-padding">
                                &nbsp;
                                </td> 
                             </tr>

 
                            <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>Passenger <br/>(if applicable)</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }} className="no-padding">
                                    <table style={{ borderWidth: '1px',width:'100%' }} className="no-padding">
                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    
                                                    <table style={{ borderWidth: '0px',width:'100%' }} className="no-padding">
                                                        <tr >
                                                            <td className="no-padding- border-bottom" style={{ borderWidth: '1px'}}>
                                                            a. Rate per km* Total Distance Travels per month (OR)
                                                            </td>
                                                            <td className="no-padding- border-bottom" style={{ borderWidth: '1px'}}>
                                                            (A)
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>

                                            <tr >
                                                <td className="no-padding border-bottom">
                                                    
                                                    <table style={{ borderWidth: '0px',width:'100%' }} className="no-padding">
                                                        <tr >
                                                            <td className="no-padding- border-bottom" style={{ borderWidth: '1px'}}>
                                                            b. Fare Per Passenger* No. of Passengers* Trip Per Month
                                                            </td>
                                                            <td className="no-padding- border-bottom" style={{ borderWidth: '1px'}}>
                                                            (A)
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                    </table>           
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }} className="no-padding">
                                 &nbsp;
                                </td> 
                             </tr>
                             

                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>Charging  Expenses</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }} className="no-padding">
                                Charging expense        
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }} className="no-padding">
                                 &nbsp;
                                </td> 
                             </tr>

                             <tr>
                                <td colSpan ="2" style={{ borderWidth: '1px',textAlign: 'center'  }}>Tyre Expenses</td>
                                <td colSpan ="8" style={{ borderWidth: '1px' }} className="no-padding">
                                  Tyre Cost * No. of Tyres* Kms Run per Month) / Tyre Life        
                                </td>
                                <td colSpan ="2" style={{ borderWidth: '1px' }} className="no-padding">
                                 &nbsp;
                                </td> 
                             </tr>
                            
                             <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                <br/> 
                                Remarks :  	
                                <br/> <br/> <br/> <br/>
                                </td>                                
                            </tr>
*/}
                            <tr>
                                <td colSpan ="12" style={{ borderWidth: '1px' }}>
                                
                                <b>Declaration by Applicant, Co-Applicant & Guarantor:</b>
                                <br/>   
                                I / We declare that all the particulars & information given in the application form are true and correct.  I/We understand that in the consequence of being found any information to be false in this application, reserves the right to recall the loan with due interest at any given point of time, after giving 15 days notice. . I/We authorise {(camDetails?.cam_lender ==='Vivriti') ? (
                                <>Vivriti Capital Limited ("VCL")</>) : (<>cKers Finance Private Limited</>)} along with its associates to retain all the documents, verify or share any information for credit appraisals or any purpose. I/We agree to share any additional information/documents required by {(camDetails?.cam_lender ==='Vivriti') ? (
                                    <>VCL</>) : (<>cKers</>)} to assess the loan from time to time. Sanction/ Rejection of this application is at the absolute discretion of {(camDetails?.cam_lender ==='Vivriti') ? (
                                        <>VCL</>) : (<>cKers</>)}. 
                                <br/> <br/>    
                                I/We authorize {(camDetails?.cam_lender ==='Vivriti') ? (
                                    <>VCL</>) : (<>cKers</>)} or any of its appointed agent  to  make references and enquires related to information in this application including credit reference check at various credit information bureaus  which may deem necessary. I/We further agree that my /our loan shall be governed by the rules  of {(camDetails?.cam_lender ==='Vivriti') ? (
                                        <>VCL</>) : (<>cKers</>)}  as  applicable  from  time  to  time.  {(camDetails?.cam_lender ==='Vivriti') ? (
                                            <>VCL</>) : (<>cKers</>)} reserves the right to accept / reject my / our application without providing any reason. I/We are aware that processing fees & applicable taxed are non-refundable. I/We are aware of the terms & conditions of {(camDetails?.cam_lender ==='Vivriti') ? (
                                                <>VCL</>) : (<>cKers</>)} and shall adhere to all norms of {(camDetails?.cam_lender ==='Vivriti') ? (
                                                    <>VCL</>) : (<>cKers</>)} in force from time to time.
                                <br/> <br/>     
                                I/We hereby expressly authorize {(camDetails?.cam_lender ==='Vivriti') ? (
                                    <>VCL</>) : (<>cKers</>)} to install Electronic Tracking Devices on the Hypothecated Vehicle or for pulling data from OEM provided systems or equivalent on Vehicle, as the case maybe. 
                                <br/> <br/>        
                                I/We hereby Expressly Authorize {(camDetails?.cam_lender ==='Vivriti') ? (
                                    <>VCL</>) : (<>cKers</>)} to send me/us, Communication regarding Loans, Insurance and Other Products from {(camDetails?.cam_lender ==='Vivriti') ? (
                                        <>VCL</>) : (<>cKers</>)}, it's Associate Companies and /or third parties through telephone calls /SMSs /emails/ post / WhatsApp Messages and other mode of communications etc., including but not limited to the Promotional communications. I/We confirm that I shall not Challenge receipt of such communications by me as unsolicited communication, defined under TRAI Regulations on unsolicited commercial communications. I/We understand that I/We can at any time opt not to receive any telecommunication by registering under Do Not Call Registry.
                                <br/> <br/>    
                                I/we will inform the Lenders of any change from time to time in the details furnished herein and agree that the Lenders have the sole discretion to reject this loan application and/or reduce the amount of loan sanctioned on any ground(s) whatsoever.
                                <br/> <br/>        
                                That I/we have not, at any point of time, had any insolvency proceedings instituted or pending against me, nor have I been declared insolvent by any court of competent jurisdiction/authority. That I/we voluntarily give my consent to the Lenders to use my KYC (Voter ID / Ration Card / Masked Aadhaar / other) and/or biometric information for authenticating / establishing my identity and/or Address proof in the manner acceptable under any Act or Law in force from time to time.
                                <br/> <br/>        

                                I/we hereby undertake and provide its consent to the Lenders or its authorized service providers, for sharing its/ their details with Central KYC Registry and receive KYC information from Central KYC Registry or from UIDAI. I/we understand that by submitting proof of possession of Aadhaar number to the Lenders or its authorized service providers, I/we hereby authorizes the Lenders or its authorized service providers a) to collect, store, use, verify, authenticate its/their Aadhaar and demographic information against UIDAI database by itself or via user Agency duly licensed by UIDAI, as permitted under the applicable law from time to time; b) to use its/their Aadhaar for financing, other banking and transaction services, as may be applicable, and c) to use or obtain its/their demographic and/or biometric information through Aadhaar based authentication (including e-KYC, Mobile OTP (One Time Password) based, biometric and/or other lawful authentication means) as permitted under the applicable law from time to time.
                                <br/> <br/>    

                                I / We hereby confirm that all charges and terms & conditions pertaining to loan are explained to me in my preferred language and I / We have understood the same.
                                <br/>      
                                </td>                                
                            </tr>
                            <tr> 
                            <td colSpan ="12" style={{ borderWidth: '1px' }}>
                            <table style={{ borderWidth: '0px',width:'100%' }} className="no-padding">
                                <tr >
                                <td style={{ borderWidth: '1px-' }}>
                                    Applicant's Photograph
                                    {(() => {
                                        const selectedArr = allLeadDocumentsArr.filter(
                                            item => item.documentTypeId === `dynamicDocument^Applicant_Photo^${leadDetails?.id}`
                                        );
                                        const documentUrl = selectedArr[0]?.document;
                                       // const newURL = loadImage(documentUrl);
                                        return (
                                            <>
                                            {documentUrl && documentUrl !== '' ? (
                                                <>
                                                <div style={{  paddingTop: "7px"}}>
                                                <img
                                                    src={documentUrl}
                                                    alt="Applicant Photograph"
                                                    style={{ display: 'inline', height: '200px', width: '200px' }}
                                                    crossOrigin="anonymous"
                                                />
                                                </div>
                                                </>
                                            ) : (
                                                <>
                                                {/* Empty space if image is not present */}
                                                <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
                                                </>
                                            )}
                                            </>
                                        );
                                        })()}
                                    
                                   
                                     Applicant's Signature 
                                     {(() => {  
                                    const selectedArr = allLeadDocumentsArr.filter(item => item.documentTypeId === `dynamicDocument^Applicant_Signature^${leadDetails?.id}` );  

                                    return ( 
                                            <>
                                            {selectedArr[0]?.document !=='' ? ( <>
                                             <div style={{  paddingTop: "7px"}}>
                                              <img src={selectedArr[0]?.document} alt="Applicant Signature" style={{  display: "inline" , height: "50px",width: "200px"}} crossOrigin="anonymous"/>
                                               </div>
                                            </>) : (<>
                                             <br/><br/>
                                            </>)} 
                                            </> 
                                        );
                                    })()}  
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px-' }}>
                                           Co-Applicant's Photograph
                                            {(() => {  
                                            const selectedArr = allLeadDocumentsArr.filter(item => item.documentTypeId === `dynamicDocument^Co_Applicant_Photo^${row.id}` );  
                                            return ( 
                                                    <>
                                                    {selectedArr[0]?.document !=='' ? ( <>
                                                    <div style={{  paddingTop: "7px"}}>
                                                    <img src={selectedArr[0]?.document} alt="Co-Applicant Photograph" style={{  display: "inline" , height: "200px",width: "200px"}} crossOrigin="anonymous"/>
                                                    </div>
                                                    </>) : (<>
                                                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                                                    </>)} 
                                                    </> 
                                                );
                                            })()}
                                            
                                        
                                            Co-Applicant's Signature 
                                            {(() => {  
                                            const selectedArr = allLeadDocumentsArr.filter(item => item.documentTypeId === `dynamicDocument^Co_Applicant_Signature^${row.id}` );  
                                            return ( 
                                                    <>
                                                    {selectedArr[0]?.document !=='' ? ( <>
                                                    <div style={{  paddingTop: "7px"}}>
                                                    <img src={selectedArr[0]?.document} alt="Co-Applicant Signature" style={{  display: "inline" , height: "50px",width: "200px"}} crossOrigin="anonymous"/>
                                                    </div>
                                                    </>) : (<>
                                                    <br/><br/>
                                                    </>)} 
                                                    </> 
                                                );
                                            })()}   
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px-' }}>
                                           Guarantors's Photograph
                                           {(() => {  
                                            const selectedArr = allLeadDocumentsArr.filter(item => item.documentTypeId === `dynamicDocument^Guarantor_Photo^${row.id}` );  
                                            return ( 
                                                    <>
                                                    {selectedArr[0]?.document !=='' ? ( <>
                                                    <div style={{  paddingTop: "7px"}}>
                                                    <img src={selectedArr[0]?.document} alt="Guarantors Photograph" style={{  display: "inline" , height: "200px",width: "200px"}} crossOrigin="anonymous"/>
                                                    </div>
                                                    </>) : (<>
                                                    <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
                                                    </>)} 
                                                    </> 
                                                );
                                            })()}
                                            
                                        
                                            Guarantors's Signature 
                                            {(() => {  
                                            const selectedArr = allLeadDocumentsArr.filter(item => item.documentTypeId === `dynamicDocument^Guarantor_Signature^${row.id}` );  
                                            return ( 
                                                    <>
                                                    {selectedArr[0]?.document !=='' ? ( <>
                                                     <div style={{  paddingTop: "7px"}}>
                                                    <img src={selectedArr[0]?.document} alt="Guarantors Signature" style={{  display: "inline" , height: "50px",width: "200px"}} crossOrigin="anonymous"/>
                                                    </div>
                                                    </>) : (<>
                                                    <br/><br/>
                                                    </>)} 
                                                    </> 
                                                );
                                            })()} 
                                        </td>
                                    ))}
                                </tr>
                             </table>   
                                </td>     
                            </tr>

                            
                        </table> 
                    
            </div>
            { /* Application Details section  :  END HERE */ }               

            { /* SCHEDULE_A section  :  START HERE */ }            
            <div className={ applicationDetailsFormActiveTab === "schedule_a" ? "" : "d-none"}> 
                 
                        <table style={{ border: '1px',width:'100%' }}>
                            <tr> 
                                <th style={{ borderWidth: '1px' }}>&nbsp;</th>
                                <th style={{ borderWidth: '1px' }}>Borrower/ Applicant</th>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <th style={{ borderWidth: '1px' }}>
                                            Co Borrower/ Co Applicant's
                                        </th>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <th style={{ borderWidth: '1px' }}>
                                            Guarantor
                                        </th>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Name</td>
                                <td style={{ borderWidth: '1px' }}>
                                    {leadDetails?.name}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                            {row?.first_name} {row?.last_name}                                       
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                            {row?.first_name} {row?.last_name}                                          
                                        </td>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Fathers/Husbands Name</td>
                                <td style={{ borderWidth: '1px' }}> 
                                {camDetails?.cam_father_name}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                        {(() => { 
                                        const rowInfoArr = coapplicantGuarantorRows.filter(item => item.id === `C${row.id}`);
                                        const nameParts = (rowInfoArr[0]?.father_name !== undefined) ? rowInfoArr[0]?.father_name : '';
                                        return (  
                                           <>
                                           {nameParts}
                                           </>
                                        );
                                        })()}
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           {(() => { 
                                            const rowInfoArr = coapplicantGuarantorRows.filter(item => item.id === `G${row.id}`);
                                            const nameParts = (rowInfoArr[0]?.father_name !== undefined) ? rowInfoArr[0]?.father_name : ''; 

                                            return ( 
                                                <>
                                                {nameParts}
                                                </>
                                            );
                                            })()}
                                        </td>
                                    ))} 
                            </tr>

                            <tr> 
                                <td style={{ borderWidth: '1px' }}>Address (including Pin Code<br/> /District)</td>
                                <td style={{ borderWidth: '1px' }}>
                                    {leadDetails?.full_address} {leadDetails?.district} {leadDetails?.pin}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                            {row?.full_address} {row?.district} {row?.pin}                             
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                            {row?.full_address} {row?.district} {row?.pin}                                
                                        </td>
                                    ))} 
                                </tr>

                                <tr> 
                                <td style={{ borderWidth: '1px' }}>Constitution 
                                </td>
                                <td style={{ borderWidth: '1px' }}>
                                    {camDetails?.cam_constitution}
                                </td>
                                
                                {addedAllCoApplicants.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                           &nbsp;                            
                                        </td>
                                    ))}

                                    {addedAllGuarantors.map((row, index) => (
                                        <td style={{ borderWidth: '1px' }}>
                                             &nbsp;                               
                                        </td>
                                    ))} 
                                </tr>


                                <tr> 
                                <td colSpan ={verticalTotalColspan} style={{ borderWidth: '1px' }}> 
                                   <b>
                                         Date of Agreement :<br/>
                                         Place of Execution of Agreement: <br/>
                                         Description of Vehicle/Asset : <br/>
                                         
                                    </b>
                                </td> 
                                </tr>

                               { /* <tr> 
                                <td colSpan ={verticalTotalColspan} style={{ borderWidth: '1px' }}> 
                                    <br/>
                                   (Attached Separate Schedule A in case of requirement as Part of the agreement)
                                </td> 
                                </tr> */ }
                            </table>

                            <table style={{ border: '1px',width:'100%' }}>
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Make</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_vehicle_maker}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Model</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_vehicle_models}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Registration No.</td>
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Engine /Motor No</td>
                                    <td style={{ borderWidth: '1px' }}>{(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Engine Number" && item.section_name === "Vehicle Dedupe"); 
                                    return ( 
                                        <>
                                        {selectedArr[0]?.vehicle_dedupe_no}
                                        </> 
                                    );
                                })()}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Chassis No.</td>
                                    <td style={{ borderWidth: '1px' }}>{(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Chasis Number" && item.section_name === "Vehicle Dedupe"); 
                                    return ( 
                                        <>
                                        {selectedArr[0]?.vehicle_dedupe_no}
                                        </> 
                                    );
                                })()}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Battery No.</td>
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Seller / Partner/Dealer Name <br/>& Location</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_dealer_name}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Number of Vehicles Financed <br/>in this Agreement</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_no_of_vehicles_owned}</td>
                                </tr> 
                            </table>
                         

                         <table style={{ border: '1px',width:'100%' }}>
                                <tr> 
                                    <td colSpan="2" style={{ borderWidth: '1px' }}><br/><b>Loan Details:</b><br/></td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Cost of Asset</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_total_cost_per_vehicle}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Interest Rate</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_iarr}%</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Loan Amount</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. {camDetails?.cam_finance_value}
                                        &nbsp; &nbsp;&nbsp;
                                        Rupees ( {(camDetails?.cam_finance_value !== undefined) ?  numberToIndianWords(camDetails?.cam_finance_value) :''} only)

                                        

                                    </td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Loan Tenure (months)</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_loan_tenor_in_months}</td>
                                </tr> 
                         </table> 


                         <table style={{ border: '1px',width:'100%' }}>
                                <tr> 
                                    <td colSpan="2" style={{ borderWidth: '1px' }}><br/><b>Repayment:</b><br/></td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>No of monthly/ quarterly instalment</td>
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Amount of each installment/Vehicle</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. {camDetails?.dmemo_emi_all_vehicle}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Period</td>
                                    <td style={{ borderWidth: '1px' }}>From</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>First Due Date</td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.dmemo_first_emi_interest_date}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Last Due Date</td>
                                    <td style={{ borderWidth: '1px' }}>
                                        
                                        {(() => {  
                                               const lastDueDate = getLastDueDate(camDetails?.dmemo_first_emi_interest_date, Number(camDetails?.dmemo_tenure) || 0);
                                             return ( 
                                                <>
                                                 {lastDueDate}
                                                </>                                               
                                             );
                                       })()}
                                        &nbsp;</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Advance Instalments (No. & Amount) </td>
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>No of PDC'S</td>
                                    <td style={{ borderWidth: '1px' }}>
                                        
                                        {(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Cheque Number" && item.section_name === "Post Dated Cheque"); 
                                    return ( 
                                        <>
                                          {selectedArr ? selectedArr.length : "0"} 
                                        </> 
                                    );
                                })()}&nbsp;</td>
                                </tr> 
                         </table> 

                          <table style={{ border: '1px',width:'100%' }}>
                                <tr> 
                                    <td colSpan="2" style={{ borderWidth: '1px' }}><br/><b>Loan terms:</b><br/></td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>LTV (Loan to Value of eL5) </td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_ltv || 0}%</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Tenure </td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_loan_tenor_in_months}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Rate of Interest </td>
                                    <td style={{ borderWidth: '1px' }}>{camDetails?.cam_iarr}%</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>EMI</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. {camDetails?.dmemo_emi_all_vehicle}</td>
                                </tr> 
                                 <tr> 
                                    <td style={{ borderWidth: '1px' }}>Loan Processing Fees</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. {camDetails?.dmemo_processing_fee_including_gst}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Agreement Charges</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. {camDetails?.dmemo_file_charge}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Penal Charges p.m.</td>
                                    <td style={{ borderWidth: '1px' }}> {leadInfo.data?.[0]?.created_at !=='' && isAfterScheduleADate(leadInfo.data?.[0]?.created_at) ? "3% P.M" : "2.5% P.M"}</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Minimum Lock in Period</td>
                                    <td style={{ borderWidth: '1px' }}>Minimum Six Months Lock in Period on closure of the account except when Foreclosure is due to Mandatory Foreclosure by the lender</td>
                                </tr> 
                                 <tr> 
                                    <td style={{ borderWidth: '1px' }}>Prepayment charges</td>
                                    <td style={{ borderWidth: '1px' }}>4% in first year 2% after first year plus GST</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Cheque/ECS Dishonor Charges</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. {leadInfo.data?.[0]?.created_at !=='' && isAfterScheduleADate(leadInfo.data?.[0]?.created_at) ? "800" : "590"}/- (Rupees Five Hundred Ninety only) Per Instance Including GST</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Cheque/ECS Swap Charges</td>
                                    <td style={{ borderWidth: '1px' }}>Rs. 590/- (Rupees Five Hundred Ninety only) Per Request Including GST</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Cash Margin/Advance EMI</td>
                                    <td style={{ borderWidth: '1px' }}>Nil</td>
                                </tr> 
                                 <tr> 
                                    <td style={{ borderWidth: '1px' }}>Other Terms</td>
                                    <td style={{ borderWidth: '1px' }}>As per Loan and Hypothecation Agreement</td>
                                </tr> 
                            </table> 

                            <table style={{ border: '1px',width:'100%' }}>
                                <tr> 
                                    <td colSpan="5" style={{ borderWidth: '1px' }}><br/>
                                    Details of Post dated cheques handed over to client –
                                    <br/></td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Drawee lender</td>
                                     <td style={{ borderWidth: '1px' }}>Account number</td>
                                     <td style={{ borderWidth: '1px' }}>Cheque Amount</td>
                                     <td style={{ borderWidth: '1px' }}>Cheque number</td>
                                     <td style={{ borderWidth: '1px' }}>Cheque Date</td>
                                </tr> 

                                 
                               
                                {(() => {  
                                    const selectedArr = leadMoreDocuments.filter(item => item.lead_id === leadDetails?.id && item.document_type === "Cheque Number" && item.section_name === "Post Dated Cheque"); 
                                    return ( 
                                        <>
                                          {selectedArr.map((rowI, index) => (
                                            <tr> 
                                                <td style={{ borderWidth: '1px' }}>{(camDetails?.cam_lender ==='Vivriti') ? (
                                                <>   
                                                Vivriti Capital Ltd
                                                </> 
                                                ) : (
                                                    <>
                                                    Ckers Finance 
                                                    </>
                                                )}</td>
                                                <td style={{ borderWidth: '1px' }}>{rowI.cheque_account_no}</td>
                                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                                <td style={{ borderWidth: '1px' }}>{rowI.cheque_no}</td>
                                                <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                            </tr>
                                        ))} 
                                        </> 
                                    );
                                })()}

                                 </table>  

                                 <table style={{ border: '1px',width:'100%' }}>
                                <tr> 
                                    <td colSpan="7" style={{ borderWidth: '1px' }}><br/>
                                    Cross sell details(Cross Sell Details-At the time of Agreement or During the Tenure  if Any)
                                    <br/></td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>Product</td>
                                     <td style={{ borderWidth: '1px' }}>Motor insurance</td>
                                     <td style={{ borderWidth: '1px' }}>Credit Life protect insurance</td>
                                     <td style={{ borderWidth: '1px' }}>GPS</td>
                                     <td style={{ borderWidth: '1px' }}>Extended Warranty</td>
                                     <td style={{ borderWidth: '1px' }}>Life Insurance</td>
                                     <td style={{ borderWidth: '1px' }}>Others (If any)</td>
                                </tr> 

                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                </tr> 
                                <tr> 
                                    <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                      <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                     <td style={{ borderWidth: '1px' }}>&nbsp;</td>
                                </tr> 

                                 </table>  
                                 <div style={{ clear: 'both' }}>&nbsp;</div>         
            </div>
            { /* schedule_a section  :  END HERE */ } 


             { /* DRF section  :  START HERE */ } 
              <div className={ applicationDetailsFormActiveTab === "drf" ? "" : "d-none"}> 
                    <table style={{ width:'100%' }}>
                        <tr> 
                            <td colSpan="3"><br/>
                            Date : {formattedDate} <br/><br/>
 
                            To, <br/><br/>
                            {(camDetails?.cam_lender ==='Vivriti') ? (
                                <>   
                                    Vivriti Capital Limited,<br/> 
                                    Prestige Zackria Metropolitan, No. 200/1-8, 2nd Floor,<br/> 
                                    Block 1, Anna Salai, Chennai-600002
                                    </> 
                            ) : (
                                <>
                                cKers Finance Private Limited<br/> 
                                Building No-24-30, First Floor, Okhla Industrial Area Phase - III, <br/> 
                                New Delhi 110020, India
                                </>
                            )}
                            
                            <br/><br/>

                            As per your sanction letter No : {camDetails?.dmemo_reference_no}&nbsp;Dated 
                                          &nbsp;{(camDetails?.dmemo_date !=='0000-00-00') ? formatDateForValue(camDetails?.dmemo_date) : ""} for Sanctioned Amount of Rs {camDetails?.dmemo_loan_amount} (Rupees {(camDetails?.dmemo_loan_amount !== undefined) ?  numberToIndianWords(camDetails?.dmemo_loan_amount) :''} only).<br/> 
                            I/ We request you to kindly Disburse Rs. {netDisbursementAmt}/- (Rupees {(netDisbursementAmt !== undefined) ?  numberToIndianWords(netDisbursementAmt) : ''} only ) as per details given below :- <br/>

                            <br/></td>
                        </tr> 
                        </table> 

                        <table style={{ border: '1px',width:'100%' }}>     
                        <tr> 
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle'}}>Sl. No. </td>
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>&nbsp;</td>
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>&nbsp;</td> 
                         </tr> 

                         <tr> 
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>1.</td>
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle', paddingBottom: '5px' }}>Account holder Name (As per Bank record)</td>
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>{dealerBenificaryName}&nbsp;</td> 
                         </tr>
                          <tr> 
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>2.</td>
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>Bank Name</td>
                            <td style={{ borderWidth: '1px' , verticalAlign: 'middle' }}>{dealerBankName}&nbsp;</td> 
                         </tr>  
                          <tr> 
                            <td style={{ borderWidth: '1px' }}>3.</td>
                            <td style={{ borderWidth: '1px' }}>Account Number </td>
                            <td style={{ borderWidth: '1px' }}>{dealerAccountNo}&nbsp;</td> 
                         </tr> 
                          <tr> 
                            <td style={{ borderWidth: '1px' }}>4.</td>
                            <td style={{ borderWidth: '1px' }}>IFSC Code (for Electronic Payment)</td>
                            <td style={{ borderWidth: '1px' }}>{dealerIfsc}&nbsp;</td> 
                         </tr>
                          <tr> 
                            <td style={{ borderWidth: '1px' }}>5.</td>
                            <td style={{ borderWidth: '1px' }}>Amount</td>
                            <td style={{ borderWidth: '1px' }}>{netDisbursementAmt}&nbsp; </td> 
                         </tr> 

                         <tr> 
                            <td colSpan="3" style={{ borderWidth: '1px' }}><br/> 
                                Note: Any correction requires counter signature by Borrower and Co-borrowers. Company will not be responsible for any change in favouring details other than details filled in this form.<br/><br/><br/><br/>

                                Yours faithfully,<br/><br/><br/>

                                ________ <br/>                              	  	
                                Borrower 
                                <div style={{ clear: 'both' }}>&nbsp;</div>
                            </td> 
                         </tr>  
                    </table> 
                    <div style={{ clear: 'both' }}>&nbsp;</div>
              </div>

              { /* DRF section  :  END HERE */ }       

         </div>
         </div>                           
      </div>
      <br/> 
          {( isReadyToModify && (userRoleType !== "" || userRoleType === 'Credit' || userRoleType === 'Superadmin')) ? (
            <>

             { savedApplicationDetailsInfo?.action_status  === '1' ? ( <> 
                { ( !enableUpdatePdfDetails) && (
                    <>
                   
                <button className='btn btn-warning text-white float-right-' onClick={handleDownloadPdf}>Generate PDF
                {preloaderStatus && (
                    <>
                      <div
                        className="spinner-border small-preloader"
                        role="status"
                      >
                        <span className="visually-hidden">
                          {" "}
                          Loading...
                        </span>
                      </div>
                    </>
                  )}
                </button>  
                
                  </>
                )}
             </> ) :
             (
                <>
                { ( !enableUpdatePdfDetails) ? (
                <button type="button" className="btn btn-primary text-white" onClick={handleToggleUpdateDetails} >Update Details</button>
                ) : (
                    <>
                    <button type="button" className="btn btn-primary text-white" onClick={handleToggleSaveDetails} >Save Details</button>

                    &nbsp;<button type="button" className="btn btn-danger text-white" onClick={handleToggleUpdateDetails} >Cancel</button>
                    </>
                )}

                { ( !enableUpdatePdfDetails) && (
                <>
                 <button className='btn btn-warning text-white float-right' onClick={handleDownloadPdf}>Generate PDF {preloaderStatus && (
                    <>
                      <div
                        className="spinner-border small-preloader"
                        role="status"
                      >
                        <span className="visually-hidden">
                          {" "}
                          Loading...
                        </span>
                      </div>
                    </>
                  )}</button>
                 
                </>
                )}

                </>
            )}

                { (savedApplicationDetailsInfo?.action_status  > 0  && savedApplicationDetailsInfo?.action_status  < 3) && ( 
                    <> 
                     <button className="btn btn-danger float-right d-none" type="button" onClick={() => btnOpenRejectData('3')} > Reversal Request </button>
                    </>
                 )} 
                </>

            ) : (
                <></>
            )} 


                { ( isReadyToModify && (userRoleType !== "" || userRoleType === 'Credit Head' || userRoleType === 'Superadmin' ) && refNo !=='' ) ? (
                  
                  <>
                    <div className='form-group text-end mb-2'>
                        <button className="btn btn-success d-none" type="button"  onClick={() => btnOpenRejectData('1')}> Approve</button>&nbsp;
                       
                        <button className="btn btn-danger d-none" type="button" onClick={() => btnOpenRejectData('2')} > Reject </button>
                    </div> 

                   
                    </>
                  
                ) : (
                  <>
                 
                   { isReadyToModify && showSanctionNote !== "" && (sanctionApproveLatestStatus === '1' )  && sanctionApproveAndSendMailLatestStatus < 1 && (
                     <div className='form-group text-end mb-2 d-none'>
                         <button className="btn btn-success" type="button"  onClick={() => btnOpenRejectData('1','1')} title="Send mail to Customer, Sales Person, CAM email and Logged-in user"> Send Mail </button>&nbsp; 
                 </div> 
                   )}
                  </>
              )}

 
            { showSanctionNote !== ""   && (
                <div className={sanctionApproveLatestStatus=== '0' ? "text-end text-primary" : ( sanctionApproveLatestStatus=== '1' ? "text-end text-success" : "text-end text-red" )}>{showSanctionNote}</div>
                )}  
        
       
    </div>
 </>
)
}

</div>
</div>
</div>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Lead Document</h4>
                    </div>

                    <div className='modal-body'>
                        <div className='row mb-2 pb-1'>
                            <div className='col-1'>&nbsp;</div>
                            <div className='col-10 ps-0'>{viewModalInfo.note}</div>
                        </div>
                    </div>
                </div>
            </Modal>

             {/* Reject REGISTRATION MODAL START */}
                  <Modal open={openRejectAmt} onClose={handleCloseRejectAmt} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <div className='modal-custom rounded'>
                          <div className='modal-head'>
                            <h4 id="modal-title">Enter Notes </h4>
                            <Button onClick={handleCloseRejectAmt} color="primary" className='btn'>
                              <i className="bi bi-x"> &nbsp;</i>
                            </Button>
                          </div>
            
                          <div className='modal-body'>
                            <form onSubmit={handleSubmit(handleRejectFormSubmit)} encType="multipart/form-data">
                              <div className="row mx-0">
                                
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label htmlFor="itr_file">
                                      <span>Notes <a style={{ color: "red" }}>*</a></span> 
                                        < textarea
                                            id='notes'
                                            name='notes'
                                            className='form-control'
                                            {...register('notes')}
                                             onChange={handleAmtRejectChange}
                                           
                                        />
            </label>
                                  </div>
                                </div>
            
                            
            
                                <div className="col-md-12">
                                  <div className="form-group mb-0">
                                    <button className="btn btn-primary mt-2">
                                      Save
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </Modal>
                    {/* Reject REGISTRATION MODAL END */}
        </>
    );
}


function mapStateToProps(state) {
    return {
        usersData: state.usersData,
        getUserModuleData: state.getUserModuleData,
        getUploadLeadDocument: state.getUploadLeadDocument,
        masterDocumentTypeData: state.masterDocumentTypeData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default), dispatch),
    } 
}
export default connect(mapStateToProps, mapDispatchToProps)(ApplicationDetails);